import UnificarCadastroCliente from './components/UnificarCadastroCliente';
import {CHAVE_SESSAO} from './components/sessaoUsuario';
import {requisitarCaixaSeguro} from './components/caixaSeguroApi';
import {centavosDigitados,decimalCaixa,moedaCaixa} from './components/dinheiroCaixa';
import {temHistoricoModalidade} from './components/historicoModalidadesCliente';
import PermutaCliente from './components/PermutaCliente';
import CreditoPrePagoCliente from './components/CreditoPrePagoCliente';
import {apiUrl} from './components/apiAmbiente';
import MovimentoAgendasDetalhe from './MovimentoAgendasDetalhe';
import {formatarIdMovimentoCaixa} from './components/acoesCaixa';
import ResumoTotaisOS, {calcularTotaisOS, subtotalOS} from './ResumoTotaisOS';
import usePermissaoAuditoriaCC from './components/usePermissaoAuditoriaCC';
import React, { useState, useEffect, useRef, useContext } from "react";
import { withRouter } from "react-router-dom";
import Loading from "./assets/loading8.gif";
import Logo from "./assets/MB_Logo.png";
import "./components/functions";
import 'react-tabulator/lib/styles.css'; // required styles
import 'react-tabulator/lib/css/tabulator.min.css'; // theme
import { ReactTabulator } from 'react-tabulator'; // for React 15.x, use import { React15Tabulator }
import { cl } from "./components/functions";
import './clientes.css';
import './gerCotacoes.css';
import './SearchBar.css'
import './clientesLoteServicos.css'
import axios from "axios";
import * as EmailValidator from 'email-validator';
import Inputmask from "inputmask";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from "moment";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Link, animateScroll as scroll } from "react-scroll";
import Hotkeys from 'react-hot-keys';
import date from 'date-and-time';
import {
  Document,
  HeadingLevel,
  ImageRun,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  VerticalAlign,
  WidthType
} from "docx";
//import * as fs from "fs";
//const fs = require('fs')

var gGlobal = require('./components/globalvar.js');

const wordIcon = function (cell, formatterParams) { //plain text value
  return "<i class='far fa-file-word'></i>";
};
const editIcon = function (cell, formatterParams) { //plain text value
  return "<i class='fas fa-edit'></i>";
};
const iconContrato = function (cell, formatterParams) { //plain text value
  return "<i class='fas fa-file-download'></i>";
};
const iconAgendas = function (cell, formatterParams) { //plain text value
  return "<i class='fas fa-calendar'></i>";
};
const iconwhatsappweb = function (cell, formatterParams) { //plain text value
  return "<i class='fa fa-whatsapp'></i>";
}

const iconLixeira = function (cell, formatterParams) { //plain text value
  //if (cell.getRow().getData().progress < 11){
  return "<i class='fa fa-trash-o'></i>";
  //} else {
  //  return "-";
  //}
}

global.gLog = [];

function rowClick(e, row) {
  ////cl('ref table: ', this.ref.table); // this is the Tabulator table instance
  //cl("rowClick id: " + row.getData().id, row, e);
  ////cl(rep);

};

const CAMPOS_ANAMNESE = [
  ['alergias_sensibilidades','Alergias/sensibilidades'],
  ['quimicas_anteriores','Químicas anteriores'],
  ['coloracao_formula','Coloração atual/fórmula'],
  ['condicao_fios_couro','Condição dos fios e couro cabeludo'],
  ['observacoes_cuidados','Observações/cuidados']
];
const URL_ANAMNESE = apiUrl('AnamneseCapilar.php');

function renderHistoricoAnamnese(historico,campo) {
  if (campo !== 'quimicas_anteriores' && campo !== 'coloracao_formula') return null;
  const itens = (historico && historico[campo]) || [];
  if (!itens.length) return null;
  return <div className="ana-historico-auto">
    <div className="ana-historico-aviso">COM BASE NO HISTÓRICO — REVISAR, POIS PODE HAVER ERRO DE LANÇAMENTO</div>
    {itens.map(item=><div key={item.idproduto} className="ana-historico-linha">{item.data} - {item.descricao}</div>)}
  </div>;
}


function renderNotasProfissionaisAnamnese(notas,campo) {
  const itens=(notas&&notas[campo])||[];
  if(!itens.length)return null;
  return <div className="ana-notas-profissionais"><div className="ana-notas-cabecalho">INFORMAÇÕES ADICIONADAS PELO PROFISSIONAL — MAIS RECENTES PRIMEIRO</div>
    {itens.map((n,i)=><div className="ana-nota-profissional" key={n.id||i}><div className="ana-nota-meta">{n.criado_em||''} · {n.profissional||'Profissional'} · Agenda {n.idagenda||'-'}</div><div>{n.texto}</div></div>)}
  </div>;
}

function Gerador() {

  const [anaCliente, setAnaCliente] = useState(null);
  const [anaDados, setAnaDados] = useState({});
  const [anaCarregando, setAnaCarregando] = useState(false);
  const [anaSalvando, setAnaSalvando] = useState(false);
  const [anaErro, setAnaErro] = useState('');
  const [anaConfirmar, setAnaConfirmar] = useState(false);
  const [Atu, setAtu] = useState([]);
  const [rep, setrep] = useState([]);
  const filtrosClientes = useRef([]);
  const controleBuscaClientes = useRef({pesquisando:false,rotaId:0});
  const [clienteRota] = useState(()=>{
    const params=new URLSearchParams(window.location.search);
    return {id:Number(params.get('cliente_id')||0),nome:params.get('cliente_nome')||''};
  });
  const [filtroClienteRota,setFiltroClienteRota] = useState(()=>new URLSearchParams(window.location.search).has('cliente_id'));
  const rotaHistoricoAberto = useRef(false);
  controleBuscaClientes.current.rotaId=filtroClienteRota?clienteRota.id:0;
  function antesDeFiltrarClientes() {
    const filtros=this.getHeaderFilters();
    filtrosClientes.current=filtros;
    controleBuscaClientes.current.pesquisando=filtros.some(f=>String(f.value??'').trim()!=='');
  }
  function focarNomeAoCarregarClientes() {
    if(controleBuscaClientes.current.rotaId)return;
    const ativo=document.activeElement;
    // Nao retirar o foco de outro filtro, formulario ou modal em uso.
    if(!ativo||ativo===document.body||ativo===document.documentElement)this.setHeaderFilterFocus('name');
  }
  function clienteVisivelNaBusca(cliente) {
    const busca=controleBuscaClientes.current;
    return busca.rotaId?Number(cliente.id)===busca.rotaId:busca.pesquisando;
  }
  const [AtuHist, setAtuHist] = useState([]);
  const [repHist, setrepHist] = useState([]);
  const [clienteHistoricoId,setClienteHistoricoId] = useState(0);
  const [loteAberto,setLoteAberto] = useState(null);
  const [loteItens,setLoteItens] = useState([]);
  const [loteSelecionados,setLoteSelecionados] = useState({});
  const [loteInicio,setLoteInicio] = useState('');
  const [loteFim,setLoteFim] = useState('');
  const [loteDiaSemana,setLoteDiaSemana]=useState('-1');
  const [loteOpcoesServicos,setLoteOpcoesServicos]=useState([]);
  const [loteServicosSelecionados,setLoteServicosSelecionados]=useState([]);
  const [loteBuscaServicos,setLoteBuscaServicos]=useState('');
  const [loteBusy,setLoteBusy] = useState(false);
  const [loteErro,setLoteErro] = useState('');
  const [loteConfirmar,setLoteConfirmar] = useState(null);
  const [loteWhatsApp,setLoteWhatsApp] = useState(null);
  const [repCliout, setrepCliout] = useState([]);
  const [AtuCad, setAtuCad] = useState([]);
  // Consultas somente leitura: extrato da Ficha CC e detalhe do agendamento.
  const [extratoCC, setExtratoCC] = useState(null);
  const podeAuditarCC=usePermissaoAuditoriaCC(extratoCC?.cliente?.id);
  const [carregandoCC, setCarregandoCC] = useState(false);
  const [erroCC, setErroCC] = useState('');
  const [mostrarTotaisCC, setMostrarTotaisCC] = useState(false);
  const [audModal, setAudModal] = useState(null);
  const [audBusca, setAudBusca] = useState('');
  const [audResultados, setAudResultados] = useState([]);
  const [audSelecionados, setAudSelecionados] = useState({});
  const [audValor, setAudValor] = useState('');
  const [audJustificativa, setAudJustificativa] = useState('');
  const [audErro, setAudErro] = useState('');
  const [audCarregando, setAudCarregando] = useState(false);
  const [audLimite, setAudLimite] = useState('');
  const [audConfirmacao, setAudConfirmacao] = useState(null);
  const [audEsperandoBusca, setAudEsperandoBusca] = useState(false);
  const audBuscaSeq = useRef(0);
  const audBuscaInicial = useRef(null);

  const [clientesComCC, setClientesComCC] = useState({});
  const [versaoIndicadoresCC, setVersaoIndicadoresCC] = useState(0);
  const [erroIndicadoresCC, setErroIndicadoresCC] = useState('');
  const [clienteCredito,setClienteCredito]=useState(null);
  const [clientePermuta,setClientePermuta]=useState(null);
  const [textoLimiteCadastro,setTextoLimiteCadastro]=useState('R$ 0,00');
  const [limiteCadastro,setLimiteCadastro]=useState(0),[limiteEmAuditoria,setLimiteEmAuditoria]=useState(false),[clienteEditando,setClienteEditando]=useState(false),[erroCadastro,setErroCadastro]=useState(''),[salvandoCadastro,setSalvandoCadastro]=useState(false);
  const [detalheMovimento, setDetalheMovimento] = useState(null);
  const [movimentoCompleto, setMovimentoCompleto] = useState(false);
  const [erroMovimento, setErroMovimento] = useState('');
  const [carregandoMovimento, setCarregandoMovimento] = useState(false);
  const [detalheAgenda, setDetalheAgenda] = useState(null);
  const [carregandoDetalhe, setCarregandoDetalhe] = useState(false);
  const [erroDetalhe, setErroDetalhe] = useState('');
  const apiConsultaClientes = apiUrl('');
  const moedaClientes = valor => (Number(valor || 0)).toLocaleString('pt-BR', {style:'currency',currency:'BRL'});
  const diaSemanaCliente = valor => {
    if (!valor) return '-';
    const m = moment(valor, ['DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true);
    return m.isValid() ? m.locale('pt-br').format('dddd').replace(/^./, ch => ch.toUpperCase()).replace('-feira', '') : '-';
  };
  const dataClientes = valor => {
    if (!valor) return '-';
    const m = moment(valor);
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : String(valor);
  };
  async function postConsultaClientes(arquivo, dados) {
    const form = new FormData();
    form.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
    Object.entries(dados).forEach(([chave, valor]) => form.set(chave, String(valor)));
    const resp = await axios.post(apiConsultaClientes + arquivo, form);
    if (!resp.data || !resp.data.ok) throw new Error((resp.data && resp.data.erro) || 'Falha ao consultar os dados.');
    return resp.data;
  }
  // Consulta leve: somente IDs dos clientes que possuem débito ou recebimento CC.
  useEffect(() => {
    let ativo = true;
    if (!Array.isArray(rep) || rep.length === 0) return;
    async function carregarIndicadoresCC() {
      try {
        const resposta = await postConsultaClientes('ConsultaClientesComCC.php', {});
        if (ativo) {
          const mapa = {};
          (resposta.ids || []).forEach(id => { mapa[Number(id)] = true; });
          setClientesComCC(mapa);
          setErroIndicadoresCC('');
          setVersaoIndicadoresCC(v => v + 1);
        }
      } catch (erro) {
        // Na indisponibilidade da API, não exibir ícones sem confirmação.
        if (ativo) {
          setClientesComCC({});
          setErroIndicadoresCC('Não foi possível consultar os indicadores CC. Verifique a API ConsultaClientesComCC.php.');
          setVersaoIndicadoresCC(v => v + 1);
        }
        console.error('Não foi possível consultar indicadores CC:', erro);
      }
    }
    carregarIndicadoresCC();
    return () => { ativo = false; };
  }, [rep]);
  // Operações restritas ao administrador: API valida assinatura, permissões e estado da auditoria.
  async function apiAuditoriaCC(acao, extras={}) {
    const form = new FormData();
    form.set('token', sessionStorage.getItem('KEY_APP_BGG') || '');
    form.set('acao', acao);
    form.set('idcliente', String(extratoCC?.cliente?.id || 0));
    Object.entries(extras).forEach(([k,v]) => form.set(k, String(v)));
    const r = await axios.post(apiConsultaClientes + 'AuditoriaClienteCC.php', form);
    if (!r.data?.ok) throw new Error(r.data?.erro || 'Falha na operação de auditoria.');
    return r.data;
  }
  function fechaAuditoriaModal() {
    if (audCarregando) return;
    audBuscaSeq.current += 1; setAudEsperandoBusca(false);
    setAudModal(null); setAudConfirmacao(null); setAudErro(''); setAudSelecionados({});
  }
  async function atualizarExtratoAuditado() {
    const id = extratoCC?.cliente?.id;
    if (!id) return;
    const r = await postConsultaClientes('ConsultaClienteCC.php', {idcliente:id});
    setExtratoCC({...r, cliente:extratoCC.cliente});
    const lista=await postConsultaClientes('ConsultaClientesComCC.php', {});
    const mapa={}; (lista.ids||[]).forEach(v=>{mapa[Number(v)]=true;});
    setClientesComCC(mapa); setVersaoIndicadoresCC(v=>v+1);
  }
  function abreAuditoriaModal(tipo, movimento=null) {
    if (!podeAuditarCC) return;
    if (extratoCC?.limite_credito !== null && extratoCC?.limite_credito !== undefined && extratoCC?.limite_credito !== '') return;
    setAudModal({tipo, movimento}); setAudResultados([]); setAudSelecionados({});
    setAudErro(''); setAudConfirmacao(null); setAudJustificativa(''); setAudValor(''); setAudLimite('');
    if (tipo === 'buscar') {
      const nome = String(extratoCC?.cliente?.name||'').trim().split(/\s+/)[0] || '';
      audBuscaInicial.current = nome;
      setAudBusca(nome);
      pesquisarPagamentosCC(nome);
    }
  }
  // Busca automática 2 segundos após a última alteração, sem disparar novamente a busca inicial.
  useEffect(() => {
    if (audModal?.tipo !== 'buscar') return;
    if (audBuscaInicial.current !== null && audBusca === audBuscaInicial.current) {
      audBuscaInicial.current = null;
      return;
    }
    audBuscaInicial.current = null;
    const termo = audBusca.trim();
    if (termo.length < 2) { setAudEsperandoBusca(false); setAudResultados([]); return; }
    setAudEsperandoBusca(true);
    const espera = setTimeout(() => { setAudEsperandoBusca(false); pesquisarPagamentosCC(termo); }, 1000);
    return () => clearTimeout(espera);
  }, [audBusca, audModal?.tipo]);
  async function pesquisarPagamentosCC(termo=audBusca) {
    const seq = ++audBuscaSeq.current;
    setAudEsperandoBusca(false);
    setAudCarregando(true); setAudErro(''); setAudSelecionados({});
    try {
      const r = await apiAuditoriaCC('buscar', {busca:String(termo).trim()});
      if (seq === audBuscaSeq.current) setAudResultados(r.movimentos||[]);
    } catch(e) {
      if (seq === audBuscaSeq.current) {setAudErro(e.response?.data?.erro || e.message || 'Erro ao pesquisar.');setAudResultados([]);}
    } finally { if (seq === audBuscaSeq.current) setAudCarregando(false); }
  }
  // Valor BR: sem símbolo R$; vírgula decimal e ponto de milhar opcionais.
  function centavosAuditoria(entrada) {
    const t = String(entrada ?? '').trim().replace(/\s/g, '');
    if (!t || !/^(?:\d{1,3}(?:\.\d{3})+|\d+)(?:,\d{1,2})?$/.test(t)) {
      throw new Error('Valor inválido. Use o padrão X.XXX,XX (vírgula para centavos).');
    }
    const n = Number(t.replace(/\./g, '').replace(',', '.'));
    if (!Number.isFinite(n) || n > 999999999) throw new Error('Valor fora do limite permitido.');
    return Math.round(n * 100);
  }
  function formatarValorBR(input) {
    const texto = String(input || '');
    // Evita zeros predefinidos e permite digitar a vírgula antes dos centavos.
    let t = texto.replace(/[^\d,]/g, '');
    const partes = t.split(',');
    let inteiro = partes[0].replace(/^0+(?=\d)/, '');
    if (inteiro) inteiro = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return inteiro + (partes.length > 1 ? ',' + partes.slice(1).join('').slice(0,2) : '');
  }
  function dadosConfirmacaoAuditoria() {
    if (!audModal) return null;
    const tipo = audModal.tipo;
    let dados={}, titulo='', resumo='';
    if (tipo === 'buscar') {
      const ids=Object.keys(audSelecionados).filter(k=>audSelecionados[k]).map(Number);
      if (!ids.length) throw new Error('Selecione pelo menos um pagamento.');
      dados={ids:JSON.stringify(ids)};
      titulo='Confirmar vínculo dos pagamentos';
      resumo='Vincular '+ids.length+' pagamento(s) à ficha de '+extratoCC.cliente.name+'? Movimentos: '+ids.join(', ')+'.';
    } else if (tipo === 'ajuste') {
      const cent=centavosAuditoria(audValor);
      if (cent<=0) throw new Error('Informe um valor maior que zero.');
      if (audJustificativa.trim().length<20) throw new Error('Justificativa obrigatória com pelo menos 20 caracteres.');
      dados={valor:(cent/100).toFixed(2),justificativa:audJustificativa.trim()};
      titulo='Confirmar acerto manual CC';
      resumo='Registrar acerto não financeiro de '+moedaClientes(cent/100)+' na ficha de '+extratoCC.cliente.name+'? O saldo será reduzido, sem entrada de dinheiro.';
    } else if (tipo === 'finalizar') {
      const cent=centavosAuditoria(audLimite);
      const minimo=Math.max(0,Math.round(Number(extratoCC.saldo||0)*100));
      if (cent<minimo) throw new Error('O limite mínimo é '+moedaClientes(minimo/100)+'.');
      dados={limite:(cent/100).toFixed(2)};
      titulo='Confirmar finalização da auditoria';
      resumo='Finalizar a auditoria de '+extratoCC.cliente.name+' com limite de '+moedaClientes(cent/100)+'? Depois disso, os ajustes manuais serão bloqueados.';
    } else if (tipo === 'desvincular' || tipo === 'excluir_ajuste') {
      const m=audModal.movimento;
      dados={idmovimento:m.movimento};
      titulo=tipo === 'desvincular' ? 'Desvincular pagamento?' : 'Cancelar acerto manual?';
      resumo='Movimento #'+m.movimento+' — '+dataClientes(m.data)+' — '+m.descricao+' — '+moedaClientes(tipo==='desvincular'?m.pagamento:Math.abs(Number(m.ajuste||m.debito||0)))+'.';
    } else throw new Error('Operação inválida.');
    return {tipo,dados,titulo,resumo};
  }
  function executarAuditoriaCC() {
    if (!audModal || audCarregando) return;
    try { setAudErro('');setAudConfirmacao(dadosConfirmacaoAuditoria()); }
    catch(e) {setAudErro(e.message || 'Verifique os dados informados.');}
  }
  async function confirmarAuditoriaCC() {
    if (!audConfirmacao || audCarregando) return;
    const {tipo,dados}=audConfirmacao;
    setAudCarregando(true);setAudErro('');
    try {
      const acao=({buscar:'vincular',ajuste:'ajustar',finalizar:'finalizar',desvincular:'desvincular',excluir_ajuste:'excluir_ajuste'})[tipo];
      await apiAuditoriaCC(acao,dados);
      await atualizarExtratoAuditado();
      setAudConfirmacao(null);setAudModal(null);setAudSelecionados({});
    } catch(e) { setAudErro(e.response?.data?.erro || e.message || 'Falha ao executar auditoria.'); setAudConfirmacao(null); }
    finally {setAudCarregando(false);}
  }
  function modalAuditoriaCC() {
    if (!audModal) return null;
    const t=audModal.tipo;
    const titulos={buscar:'Localizar Pagamentos',ajuste:'Ajuste de Saldo CC',finalizar:'Finalizar Auditoria',desvincular:'Desvincular Pagamento',excluir_ajuste:'Cancelar Acerto Manual CC'};
    return <div className="mbcli-modal-fundo" role="presentation" onMouseDown={e=>{if(e.target===e.currentTarget)fechaAuditoriaModal();}}>
      <div className="mbcli-modal mbcli-auditoria-modal" role="dialog" aria-modal="true" aria-label={titulos[t]}>
        <div className="mbcli-modal-top"><h4>{titulos[t]} — {extratoCC?.cliente?.name}</h4><button type="button" className="btn btn-secondary btn-sm" disabled={audCarregando} onClick={fechaAuditoriaModal}>Fechar</button></div>
        <div className="mbcli-modal-conteudo">
          {audConfirmacao ? <>
            <div className="mbcli-confirmacao"><h5>{audConfirmacao.titulo}</h5><p>{audConfirmacao.resumo}</p><p className="text-muted">Confirme somente depois de conferir os dados e o cliente.</p></div>
            {audErro && <div className="alert alert-danger">{audErro}</div>}
            <div className="mbcli-auditoria-rodape"><button type="button" className="btn btn-secondary" disabled={audCarregando} onClick={()=>setAudConfirmacao(null)}>Voltar</button><button type="button" className="btn btn-success" disabled={audCarregando} onClick={confirmarAuditoriaCC}>{audCarregando?'Gravando...':'Confirmar operação'}</button></div>
          </> : <>
          {t==='buscar' && <>
            <label htmlFor="audBuscaInput">Nome a pesquisar</label>
            <div className="input-group mb-2 mbcli-busca-compacta"><input id="audBuscaInput" className="form-control" value={audBusca} onChange={e=>{audBuscaSeq.current += 1;setAudCarregando(false);setAudSelecionados({});setAudBusca(e.target.value);setAudEsperandoBusca(true);}} onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault();pesquisarPagamentosCC();}}} placeholder="Nome ou palavras da descrição"/><div className="input-group-append"><button type="button" className="btn btn-info" disabled={audCarregando} onClick={()=>pesquisarPagamentosCC()} title="Pesquisar agora"><i className="fas fa-search"/></button></div></div>
            {(audCarregando || audEsperandoBusca) && <div className="mbcli-busca-status" role="status"><i className="fas fa-spinner fa-spin"/> {audCarregando ? 'Pesquisando pagamentos...' : 'Aguardando 2 segundos após a digitação...'}</div>}
            <div className="mbcli-auditoria-lista"><table className="table table-sm table-striped"><thead><tr><th><input type="checkbox" title="Selecionar ou desmarcar todas as ocorrências disponíveis" checked={loteItens.some(a=>a.elegivel&&moment(a.start).isAfter(moment())) && loteItens.filter(a=>a.elegivel&&moment(a.start).isAfter(moment())).every(a=>loteSelecionados[a.id])} disabled={loteBusy} onChange={e=>{const mapa={};if(e.target.checked)loteItens.forEach(a=>{if(a.elegivel&&moment(a.start).isAfter(moment()))mapa[a.id]=true;});setLoteSelecionados(mapa);}} /></th><th>ID</th><th>Data</th><th>Descrição</th><th>Valor</th></tr></thead><tbody>
              {audResultados.length ? audResultados.map(m=><tr key={m.id}><td><input type="checkbox" checked={!!audSelecionados[m.id]} disabled={!m.elegivel || audCarregando} title={!m.elegivel ? 'Registro já vinculado ou não elegível' : ''} onChange={e=>setAudSelecionados(prev=>({...prev,[m.id]:e.target.checked}))}/></td><td>{m.id}</td><td>{dataClientes(m.createdAt)}</td><td>{m.descricao} {!m.elegivel && <small className="text-muted">(já vinculado)</small>}</td><td className="text-right">{moedaClientes(m.valor)}</td></tr>) : <tr><td colSpan="5" className="text-center">{audCarregando?'Pesquisando...':audEsperandoBusca?'Aguardando pesquisa...':'Nenhum resultado encontrado.'}</td></tr>}
            </tbody></table></div>
          </>}
          {t==='ajuste' && <><p className="text-danger"><strong>Só lance o valor aqui se realmente não conseguiu mais encontrar pagamentos manuais.</strong></p><label>Valor R$ para reduzir o saldo</label><input className="form-control mb-3" value={audValor} onChange={e=>setAudValor(formatarValorBR(e.target.value))} placeholder="" inputMode="decimal"/><small className="d-block text-muted mb-3">Digite o valor do acerto no padrão X.XXX,XX, sem R$. O acerto reduzirá o saldo devedor estimado de {moedaClientes(Math.max(0,Number(extratoCC?.saldo||0)))}. Não gera entrada de dinheiro.</small><label>Justificativa (mínimo 20 caracteres)</label><textarea className="form-control" rows="3" value={audJustificativa} onChange={e=>setAudJustificativa(e.target.value)} placeholder="Descreva a conferência e o motivo do ajuste."/></>}
          {t==='finalizar' && <><p>Após finalizar a auditoria, não será mais possível fazer ajustes manuais nesta tela.</p><label>Limite de crédito (CC) — Valor R$</label><input className="form-control mb-2" inputMode="decimal" value={audLimite} onChange={e=>setAudLimite(formatarValorBR(e.target.value))} placeholder=""/><small>Informe 0 se o cliente não terá mais CC. O limite mínimo atual é <strong>{moedaClientes(Math.max(0,Number(extratoCC?.saldo||0)))}</strong>. Se houver dívida, não será aceito limite inferior a ela.</small></>}
          {t==='desvincular' && <><p>Deseja desvincular este pagamento manual do cliente?</p><p><strong>Movimento:</strong> #{audModal.movimento.movimento}</p><p><strong>Data:</strong> {dataClientes(audModal.movimento.data)}</p><p><strong>Descrição:</strong> {audModal.movimento.descricao}</p><p><strong>Valor:</strong> {moedaClientes(audModal.movimento.pagamento)}</p><p>O movimento continuará existindo no caixa. Apenas `idcliente` e `ref` ficarão nulos.</p></>}
          {t==='excluir_ajuste' && <><p>Deseja cancelar este acerto manual? O movimento continuará no histórico do banco, com status cancelado, e deixará de afetar o saldo CC.</p><p><b>Movimento:</b> #{audModal.movimento.movimento}</p><p><b>Descrição:</b> {audModal.movimento.descricao}</p><p><b>Valor:</b> {moedaClientes(Math.abs(Number(audModal.movimento.ajuste||0)))}</p></>}
          {audErro && <div className="alert alert-danger mt-3">{audErro}</div>}
          <div className="mbcli-auditoria-rodape"><button type="button" className="btn btn-secondary" disabled={audCarregando} onClick={fechaAuditoriaModal}>Cancelar</button><button type="button" className="btn btn-success" disabled={audCarregando} onClick={executarAuditoriaCC}>{audCarregando?'Processando...':({buscar:'Vincular pagamento',ajuste:'Gravar ajuste',finalizar:'Finalizar auditoria',desvincular:'Confirmar desvinculação',excluir_ajuste:'Cancelar acerto'})[t]}</button></div>
          </>}
        </div>
      </div>
    </div>;
  }
  async function visualizarMovimentoCC(id, completo=false) {
    setMovimentoCompleto(completo);
    setDetalheMovimento({id});
    setErroMovimento('');
    setCarregandoMovimento(true);
    try {
      const retorno = await postConsultaClientes('ConsultaDetalheMovimentoCliente.php', {idmovimento:id});
      setDetalheMovimento(retorno.movimento);
    } catch(e) { setErroMovimento(e.message || 'Erro ao consultar movimento.'); }
    finally { setCarregandoMovimento(false); }
  }
  function abrirAcaoIndividual(agenda,acao){
    // Ações reutilizam o gerenciador autenticado e selecionam somente a ocorrência clicada.
    abrirLote(agenda.multiplo ? Number(agenda.multiplo) : -Number(agenda.id), agenda.id, acao==='cancelar'?'cancelar':null);
  }
  const urlApiLote=apiUrl('AgendaLoteGerenciar.php');
  async function postLote(acao,extras={}){
    const fd=new FormData();fd.set('token',sessionStorage.getItem('KEY_APP_BGG')||'');fd.set('acao',acao);
    fd.set('multiplo',String(loteAberto||extras.multiplo||0));fd.set('idcli',String(clienteHistoricoId));fd.set('user',String(global.gIdUser||0));
    Object.entries(extras).forEach(([k,v])=>fd.set(k,String(v)));
    const {data}=await axios.post(urlApiLote,fd);if(!data?.ok)throw new Error(data?.erro||'Falha na operação');return data;
  }
  async function abrirLote(id, selecionarId=null, acaoInicial=null){
    if(!clienteHistoricoId)return;
    setLoteAberto(Number(id));setLoteItens([]);setLoteSelecionados({});setLoteBuscaServicos('');setLoteErro('');setLoteConfirmar(null);setLoteWhatsApp(null);setLoteBusy(true);
    try{
      const r=await postLote('listar',{multiplo:Number(id)});
      setLoteItens(r.agendas||[]);setLoteOpcoesServicos(r.servicos_disponiveis||[]);
      const primeiroServ=(r.agendas||[]).find(x=>x.elegivel);
      setLoteServicosSelecionados((primeiroServ?.servicos||'').split(', ').filter(Boolean).map(nome=>(r.servicos_disponiveis||[]).find(x=>x.descricao===nome)?.id).filter(Boolean).map(String));
      const marcacaoInicial={};
      (r.agendas||[]).forEach(a=>{if(a.elegivel && moment(a.start).isAfter(moment()) && (!selecionarId || Number(a.id)===Number(selecionarId)))marcacaoInicial[a.id]=true;});
      setLoteSelecionados(marcacaoInicial);
      if(acaoInicial==='cancelar' && selecionarId && marcacaoInicial[selecionarId])setLoteConfirmar({acao:'cancelar',ids:[Number(selecionarId)]});
      const primeiro=(r.agendas||[]).find(x=>x.elegivel);
      if(primeiro){setLoteInicio(moment(primeiro.start).format('HH:mm'));setLoteFim(moment(primeiro.end).format('HH:mm'));}
    }catch(e){setLoteErro(e.response?.data?.erro||e.message||'Não foi possível abrir o lote');}
    finally{setLoteBusy(false);}
  }
  async function executarLote(){
    if(!loteConfirmar||loteBusy)return;
    const acao=loteConfirmar.acao,ids=loteConfirmar.ids;
    setLoteBusy(true);setLoteErro('');
    try{
      await postLote(acao,{ids:JSON.stringify(ids),...(acao==='alterar_horario'?{hora_inicio:loteInicio,hora_fim:loteFim,dia_semana:loteDiaSemana}:{}),...(acao==='alterar_servicos'?{servicos_ids:JSON.stringify(loteServicosSelecionados)}:{})});
      const dados=await postLote('listar');setLoteItens(dados.agendas||[]);setLoteSelecionados({});setLoteConfirmar(null);
      const cli=(rep||[]).find(c=>Number(c.id)===Number(clienteHistoricoId));
      const telefone=String(cli?.fone||'').replace(/\D/g,'');
      const numero=telefone.length===11||telefone.length===10?'55'+telefone:telefone;
      if(/^55\d{10,11}$/.test(numero)){
        const linhas=(dados.agendas||[]).filter(a=>ids.includes(Number(a.id))).map(a=>'#'+a.id+' – '+moment(a.start).format('DD/MM/YYYY HH:mm')+'–'+moment(a.end).format('HH:mm')+' ('+a.status+')');
        const mensagem='Olá '+(cli?.name||'')+', seguem as atualizações dos seus agendamentos no Espaço Márcio Bagagine:\n\n'+linhas.join('\n')+'\n\nQualquer dúvida, estamos à disposição.';
        setLoteWhatsApp({numero,mensagem});
      }
      setAtuHist({idcli:clienteHistoricoId,refresh:Date.now()});
    }catch(e){setLoteErro(e.response?.data?.erro||e.message||'Falha ao salvar');setLoteConfirmar(null);}
    finally{setLoteBusy(false);}
  }
  function prepararAcaoLote(acao){
    const ids=Object.keys(loteSelecionados).filter(id=>loteSelecionados[id]).map(Number);
    if(!ids.length){setLoteErro('Selecione pelo menos uma ocorrência elegível.');return;}
    if(acao==='alterar_servicos'&&!loteServicosSelecionados.length){setLoteErro('Selecione pelo menos um serviço.');return;}
    if(acao==='alterar_horario'&&(!/^\d{2}:\d{2}$/.test(loteInicio)||!/^\d{2}:\d{2}$/.test(loteFim)||loteFim<=loteInicio)){setLoteErro('Horário inicial e final inválidos.');return;}
    setLoteErro('');setLoteConfirmar({acao,ids});
  }
  function painelLote(){
    if(!loteAberto)return null;
    const marcados=Object.keys(loteSelecionados).filter(k=>loteSelecionados[k]).length;
    return <div className="mbcli-modal-fundo" role="presentation"><div className="mbcli-modal" role="dialog" aria-modal="true" aria-label="Gerenciar agendamentos múltiplos">
      <div className="mbcli-modal-top"><h4>{loteAberto<0?'Agendamento #'+(-loteAberto):'Lote de Agendamentos #'+loteAberto}</h4><button type="button" className="btn btn-secondary btn-sm" disabled={loteBusy} onClick={()=>{setLoteAberto(null);setLoteConfirmar(null);}}>Fechar</button></div>
      <div className="mbcli-modal-conteudo">
        <p>Selecione apenas as ocorrências que deseja alterar. Atendimentos realizados, em andamento ou vinculados ao caixa permanecem bloqueados.</p>
        <div className="mbcli-tabela-wrap"><table className="table table-sm table-striped"><thead><tr><th>Sel.</th><th>ID</th><th>Data/hora</th><th>Profissional</th><th>Status</th><th>Serviços</th></tr></thead><tbody>{loteItens.map(a=><tr key={a.id}><td><input type="checkbox" disabled={!a.elegivel||loteBusy||!moment(a.start).isAfter(moment())} checked={!!loteSelecionados[a.id]} onChange={e=>setLoteSelecionados(v=>({...v,[a.id]:e.target.checked}))}/></td><td>{a.id}</td><td>{moment(a.start).format('DD/MM/YYYY HH:mm')}–{moment(a.end).format('HH:mm')}</td><td>{a.profissional}</td><td>{a.status}{!a.elegivel?' (bloqueado)':''}</td><td>{a.servicos}</td></tr>)}</tbody></table></div>
        <div className="mbcli-dia-original"><i className="far fa-calendar-alt"/> Dia original do lote: <strong>{loteItens.length ? diaSemanaCliente(loteItens[0].start) : '-'}</strong></div>
        <div className="form-row"><div className="form-group col-md-4"><label>Alterar dia da semana</label><select className="form-control" value={loteDiaSemana} onChange={e=>setLoteDiaSemana(e.target.value)} disabled={loteBusy}><option value="-1">Manter dia original</option><option value="0">Domingo</option><option value="1">Segunda-feira</option><option value="2">Terça-feira</option><option value="3">Quarta-feira</option><option value="4">Quinta-feira</option><option value="5">Sexta-feira</option><option value="6">Sábado</option></select></div><div className="form-group col-md-3"><label>Nova hora inicial</label><input type="time" className="form-control" value={loteInicio} onChange={e=>setLoteInicio(e.target.value)} disabled={loteBusy}/></div><div className="form-group col-md-3"><label>Nova hora final</label><input type="time" className="form-control" value={loteFim} onChange={e=>setLoteFim(e.target.value)} disabled={loteBusy}/></div></div>
        <p className="text-muted">A alteração pode trocar o dia da semana mantendo a sequência semanal, preservando os serviços. O cancelamento é individual por ocorrência selecionada e não altera a ficha financeira.</p>
        <div className="form-group mbcli-lote-servicos">
          <label>Alterar serviços das ocorrências selecionadas</label>
          <p className="text-muted mb-2">Selecione os serviços à esquerda para incluí-los. Os escolhidos aparecem à direita e podem ser removidos antes de confirmar.</p>
          <div className="mbcli-lote-dual">
            <div className="mbcli-lote-dual-col">
              <div className="mbcli-lote-dual-cabecalho">Serviços disponíveis <span>{loteOpcoesServicos.filter(s=>!loteServicosSelecionados.includes(String(s.id))).length}</span></div>
              <input type="search" className="form-control form-control-sm mbcli-lote-busca" value={loteBuscaServicos} onChange={e=>setLoteBuscaServicos(e.target.value)} placeholder="Pesquisar serviço..." aria-label="Pesquisar serviços disponíveis" disabled={loteBusy}/>
              <div className="mbcli-lote-dual-lista" role="list" aria-label="Serviços disponíveis">
                {loteOpcoesServicos.filter(s=>!loteServicosSelecionados.includes(String(s.id)) && String(s.descricao||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('pt-BR').includes(loteBuscaServicos.normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLocaleLowerCase('pt-BR'))).map(s=><button key={s.id} type="button" className="mbcli-lote-dual-item" disabled={loteBusy} title={'Adicionar '+s.descricao} onClick={()=>setLoteServicosSelecionados(v=>v.includes(String(s.id))?v:[...v,String(s.id)])}><span>{s.descricao}</span><span className="mbcli-lote-dual-adicionar" aria-hidden="true">+ Adicionar</span></button>)}
                {!loteOpcoesServicos.some(s=>!loteServicosSelecionados.includes(String(s.id)) && String(s.descricao||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('pt-BR').includes(loteBuscaServicos.normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLocaleLowerCase('pt-BR')))&&<div className="mbcli-lote-dual-vazio">Nenhum serviço disponível para esta busca.</div>}
              </div>
            </div>
            <div className="mbcli-lote-dual-col">
              <div className="mbcli-lote-dual-cabecalho">Serviços selecionados <span>{loteServicosSelecionados.length}</span></div>
              <div className="mbcli-lote-dual-selecionados" role="list" aria-label="Serviços selecionados">
                {loteServicosSelecionados.map(id=>{const serv=loteOpcoesServicos.find(s=>String(s.id)===String(id));return <button key={id} type="button" className="mbcli-lote-dual-item mbcli-lote-dual-escolhido" disabled={loteBusy} title={'Remover '+(serv?.descricao||id)} onClick={()=>setLoteServicosSelecionados(v=>v.filter(x=>x!==id))}><span>{serv?.descricao||('Serviço #'+id)}</span><span className="mbcli-lote-dual-remover" aria-hidden="true">× Remover</span></button>;})}
                {!loteServicosSelecionados.length&&<div className="mbcli-lote-dual-vazio">Nenhum serviço selecionado.</div>}
              </div>
            </div>
          </div>
          <small className="text-muted">A alteração substitui os serviços dos agendamentos selecionados e seus insumos padrão. Os atendimentos finalizados não são modificados.</small>
        </div>
        {loteWhatsApp&&<div className="mbcli-whats-pergunta" role="dialog" aria-label="Enviar atualização pelo WhatsApp">
          <div className="mbcli-whats-titulo"><i className="fab fa-whatsapp"/> Alteração concluída</div>
          <p>Deseja abrir o WhatsApp com a atualização para a cliente?</p>
          <div className="d-flex flex-wrap" style={{gap:8}}>
            <button type="button" className="btn btn-success btn-sm" onClick={()=>{const {numero,mensagem}=loteWhatsApp;setLoteWhatsApp(null);window.open('https://wa.me/'+numero+'?text='+encodeURIComponent(mensagem),'_blank','noopener,noreferrer');}}>Abrir WhatsApp</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={()=>setLoteWhatsApp(null)}>Não enviar agora</button>
          </div>
        </div>}
        {loteErro&&<div className="alert alert-warning">{loteErro}</div>}
        {loteConfirmar?<div className="alert alert-warning"><b>Confirma {loteConfirmar.acao==='cancelar'?'o cancelamento':loteConfirmar.acao==='alterar_servicos'?'a alteração de serviços':'o reagendamento'} de {loteConfirmar.ids.length} ocorrência(s)?</b><div className="mt-2"><button className="btn btn-secondary btn-sm mr-2" disabled={loteBusy} onClick={()=>setLoteConfirmar(null)}>Voltar</button><button className="btn btn-danger btn-sm" disabled={loteBusy} onClick={executarLote}>{loteBusy?'Processando...':'Confirmar operação'}</button></div></div>:<div><button className="btn btn-info btn-sm mr-2" disabled={loteBusy||!marcados} onClick={()=>prepararAcaoLote('alterar_horario')}>Alterar horário ({marcados})</button><button className="btn btn-outline-info btn-sm mr-2" disabled={loteBusy||!marcados||!loteServicosSelecionados.length} onClick={()=>prepararAcaoLote('alterar_servicos')}>Alterar serviços ({marcados})</button><button className="btn btn-outline-danger btn-sm" disabled={loteBusy||!marcados} onClick={()=>prepararAcaoLote('cancelar')}>Cancelar agendamentos selecionados ({marcados})</button></div>}
        <div className="d-flex align-items-center flex-wrap mt-3 pt-3" style={{borderTop:'1px solid #dee2e6',gap:10}}>
          <button type="button" className="btn btn-secondary btn-sm" disabled={loteBusy} onClick={()=>{setLoteConfirmar(null);setLoteAberto(null);}}>
            <i className="fas fa-arrow-left mr-1" aria-hidden="true"/> Sair / Voltar
          </button>
          <span className="text-muted" style={{fontSize:13}}>Sem fazer alterações nos agendamentos</span>
        </div>
      </div></div></div>;
  }

  function fecharHistCliente() {
    const el = document.getElementById('panelHist');
    if (el) el.style.display = 'none';
  }
  async function visualizarExtratoCC(cliente) {
    fecharHistCliente();
    setMostrarTotaisCC(false);
    setExtratoCC({cliente, movimentos:[], total_debitos:0, total_pagamentos:0, saldo:0});
    setErroCC(''); setCarregandoCC(true);
    try {
      const retorno = await postConsultaClientes('ConsultaClienteCC.php', {idcliente:cliente.id});
      setExtratoCC({...retorno, cliente});
    } catch (e) { setErroCC(e.message || 'Não foi possível consultar o extrato.'); }
    finally { setCarregandoCC(false); }
  }
  const sequenciaDetalheAgenda = useRef(0);
  async function visualizarDetalheAgenda(id) {
    const sequencia = ++sequenciaDetalheAgenda.current;
    setDetalheAgenda({agenda:{id}, lancamentos:[], insumos:[], pagamentos:[]});
    setErroDetalhe(''); setCarregandoDetalhe(true);
    try {
      const retorno = await postConsultaClientes('ConsultaDetalheAgendaCliente.php', {idagenda:id});
      if (sequencia === sequenciaDetalheAgenda.current) setDetalheAgenda(retorno);
    } catch (e) { if (sequencia === sequenciaDetalheAgenda.current) setErroDetalhe(e.message || 'Não foi possível consultar o agendamento.'); }
    finally { if (sequencia === sequenciaDetalheAgenda.current) setCarregandoDetalhe(false); }
  }



  const [DocNow, setDocNow] = useState([]);

  const isFirstRunAtuCad = useRef(true);
  const isFirstRunAtuHist = useRef(true);



  useEffect(() => {


  }, [rep])

  useEffect(() => {


  }, [repHist])

  useEffect(() => {



  }, [DocNow])


  useEffect(() => {


  }, [repCliout])


  useEffect(() => {
    /*     if (isFirstRunDados.current) {
          isFirstRunDados.current = false;
          //cl("FirstRunDados false")
          return;
        } */
    let ignore = false;

    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      //bodyFormData.set('numcontr', gGlobal.gContrato);
      bodyFormData.set('comp', 1);
      //bodyFormData.set('password', password);
      //bodyFormData.append('password', 'senha');
      const urlfull = apiUrl('listaCli.php');
      //cl("urlfull",urlfull);
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      //cl("response",response);
      setrepCliout(response);
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setrep(redata2);
        } else {
          setrep(redata);
        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
    }
    fetchdata();
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [Atu])

  useEffect(() => {
    if (isFirstRunAtuHist.current) {
      isFirstRunAtuHist.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    const { idcli } = AtuHist;


    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      //bodyFormData.set('numcontr', gGlobal.gContrato);
      bodyFormData.set('idcli', idcli);
      //bodyFormData.set('password', password);
      //bodyFormData.append('password', 'senha');
      const urlfull = apiUrl('listaCliHist.php');
      //cl("urlfull",urlfull);
      const response = await axios({
        method: 'post',
        url: urlfull,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      cl("setrepHist",response);
      setrepCliout(response);
      if (!ignore) {
        const redata = [{}];
        const redata2 = response['data'];
        if (redata2) {
          setrepHist(redata2);
        } else {
          setrepHist(redata);
        }
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
        let edivLoadHist = document.getElementById('divLoadHist');
        if (edivLoadHist) { edivLoadHist.style.display = 'none'; }
      }
    }
    fetchdata();
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuHist])

  useEffect(() => {
    if (isFirstRunAtuCad.current) {
      isFirstRunAtuCad.current = false;
      //cl("FirstRunDados false")
      return;
    }
    let ignore = false;

    async function fetchdata() {
      var bodyFormData = new FormData();
      bodyFormData.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfcidcli');
      bodyFormData.set('id', AtuCad.id);
      bodyFormData.set('name', AtuCad.name);
      bodyFormData.set('email', AtuCad.email);
      bodyFormData.set('fone', AtuCad.fone);
      bodyFormData.set('dtnasc', AtuCad.dtnasc);
      bodyFormData.set('end', AtuCad.end);
      bodyFormData.set('num', AtuCad.num);
      bodyFormData.set('compl', AtuCad.compl);
      bodyFormData.set('cidade', AtuCad.cidade);
      bodyFormData.set('estado', AtuCad.estado);
      bodyFormData.set('cep', AtuCad.cep);
      bodyFormData.set('bairro', AtuCad.bairro);
      bodyFormData.set('obs', AtuCad.obs);
      bodyFormData.set('log', JSON.stringify(global.gLog));
      bodyFormData.set('user', global.gIdUser);
      bodyFormData.set('token',sessionStorage.getItem(CHAVE_SESSAO)||'');
      bodyFormData.set('limite_credito',AtuCad.limite_credito);bodyFormData.set('revisao',AtuCad.revisao||'');

      setSalvandoCadastro(true);
      try {const response=await requisitarCaixaSeguro('CliAtu.php',bodyFormData);
      if(!response.data?.ok)throw new Error('Cadastro não confirmado.');
      global.inpAddFrmC.inputFone=false;global.inpAddFrmC.inputNome=false;
      const painel=document.getElementById('panelActions');if(painel)painel.style.display='none';
      if(clienteHistoricoId) setAtuHist({idcli:clienteHistoricoId});
      if(extratoCC?.cliente?.id===Number(AtuCad.id))visualizarExtratoCC(extratoCC.cliente);
      //cl("response",response);
      //setrepCliout(response);
      setAtu({ '0': '0' });
      if (!ignore) {
        /*         const redata = [{}];
                const redata2 = response['data'];
                if (redata2) {
                  setrep(redata2);
                } else {
                  setrep(redata);
                } */
        //const redata = [{prop:"1210140551/19", contr:"C1210140551/19",cliente:"CONDOMINIO EDIFICIO VILA CAROLINA",tipo:"Auditoria de Gestão",status:"Editando"}];
        //cl(redata);


        let eleLoading = document.getElementById('divLoad');
        if (eleLoading) { eleLoading.style.display = 'none'; };
      }
      }catch(e){if(!ignore)setErroCadastro(e.message);}finally{if(!ignore)setSalvandoCadastro(false);}
    }
    if (global.gAtuCad === 1) {

      fetchdata();
      global.gAtuCad = 0;

    } else { return };
    //cl('gcontrato', gGlobal.gContrato);

    return () => { ignore = true };
  }, [AtuCad])

  const ref = null;


  function visualizarHist(id, nome) {
    setExtratoCC(null);
    setClienteHistoricoId(Number(id));
    let eleLoading = document.getElementById('divLoad');
    if (eleLoading) { eleLoading.style.display = ''; };    
    let edivLoadHist = document.getElementById('divLoadHist');
    if (edivLoadHist) { edivLoadHist.style.display = ''; }
    let etituloHist = document.getElementById('tituloHist');
    etituloHist.innerHTML = nome + ' - Histórico de Agendamentos';
    let epanelHist = document.getElementById('panelHist');
    if(epanelHist){epanelHist.style.display = '';}
    setAtuHist({ idcli: id })
  }


  useEffect(()=>{
    if(!filtroClienteRota || rotaHistoricoAberto.current || !clienteRota.id || !Array.isArray(rep) || !rep.length)return;
    const cli=rep.find(x=>Number(x.id)===clienteRota.id);
    if(!cli)return;
    rotaHistoricoAberto.current=true;
    visualizarHist(cli.id,cli.name||clienteRota.nome||'Cliente');
    const destino=document.getElementById('panelHist');
    if(destino)destino.scrollIntoView({behavior:'smooth',block:'start'});
  },[rep,clienteRota.id,filtroClienteRota]);

  const [anaHistorico,setAnaHistorico] = useState({});
  const [anaNotas,setAnaNotas] = useState({});
  async function consultarAnaCliente(cliente) {
    setAnaCliente(cliente);setAnaNotas({}); setAnaHistorico({}); setAnaErro(''); setAnaConfirmar(false); setAnaDados({}); setAnaCarregando(true);
    try {
      const fd = new FormData(); fd.set('apikey', '$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4'); fd.set('acao','consultar'); fd.set('idcliente',cliente.id);
      const {data} = await axios.post(URL_ANAMNESE,fd);
      if (!data || !data.ok) throw new Error(data?.erro || 'Falha na consulta da anamnese');
      setAnaDados(data.ficha || {}); setAnaHistorico(data.historico || {});setAnaNotas(data.notas||{});
    } catch(e) {setAnaErro(e.response?.data?.erro || e.message || 'Erro na consulta');}
    finally {setAnaCarregando(false);}
  }
  async function salvarAnaCliente() {
    if (!anaCliente || anaSalvando) return;
    setAnaSalvando(true);setAnaErro('');setAnaConfirmar(false);
    try {
      const fd=new FormData();fd.set('apikey','$#T#@!M%T@$MG@$OJG48ugyf987nszovhunfc4');
      fd.set('acao','salvar');fd.set('idcliente',anaCliente.id);fd.set('user',global.gIdUser||0);
      CAMPOS_ANAMNESE.forEach(([campo])=>fd.set(campo,anaDados[campo]||''));
      const {data}=await axios.post(URL_ANAMNESE,fd);
      if (!data?.ok) throw new Error(data?.erro || 'Falha ao salvar');
      setAnaCliente(null);
    } catch(e) {setAnaErro(e.response?.data?.erro || e.message || 'Falha ao salvar');}
    finally {setAnaSalvando(false);}
  }
  function modalAnaCliente() {
    if (!anaCliente) return null;
    return <div className="ana-overlay" onMouseDown={e=>{if(e.target===e.currentTarget && !anaSalvando)setAnaCliente(null);}}>
      <div className="ana-modal" role="dialog" aria-modal="true" aria-label="Anamnese capilar">
        <div className="ana-header"><h4>Ficha Anamnese Capilar — {anaCliente.name}</h4><button className="btn btn-sm btn-secondary" onClick={()=>setAnaCliente(null)} disabled={anaSalvando}>Fechar</button></div>
        <div className="ana-body">
          {anaCarregando ? <p><i className="fas fa-spinner fa-spin"/> Carregando ficha...</p> : <>
            {CAMPOS_ANAMNESE.map(([campo,rotulo])=><div key={campo} className="form-group"><label>{rotulo}</label><textarea rows={3} className="form-control" value={anaDados[campo]||''} onChange={e=>setAnaDados(prev=>({...prev,[campo]:e.target.value}))}/>{renderHistoricoAnamnese(anaHistorico,campo)}{renderNotasProfissionaisAnamnese(anaNotas,campo)}</div>)}
            {anaErro && <div className="alert alert-danger">{anaErro}</div>}
            {anaConfirmar && <div className="ana-confirm"><strong>Confirma a gravação da anamnese de {anaCliente.name}?</strong><div><button className="btn btn-secondary btn-sm" onClick={()=>setAnaConfirmar(false)}>Voltar</button> <button className="btn btn-success btn-sm" disabled={anaSalvando} onClick={salvarAnaCliente}>Confirmar e gravar</button></div></div>}
          </>}
        </div>
        <div className="ana-footer"><button className="btn btn-secondary" onClick={()=>setAnaCliente(null)} disabled={anaSalvando}>Cancelar</button><button className="btn btn-success" disabled={anaCarregando||anaSalvando||anaConfirmar} onClick={()=>setAnaConfirmar(true)}>Gravar</button></div>
      </div>
    </div>;
  }

  const columns = [
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    { title: 'Id', field: 'id', hozAlign: 'center', width: 60, responsive: 0 },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    { title: 'Nome', field: 'name', hozAlign: "left", width: 250, responsive: 0, headerSort: true, headerFilter: "input", sorter: "string", headerSortStartingDir: "asc" },
    {
      title: 'Fone', field: 'fone', hozAlign: "left", width: 120, responsive: 0, headerSort: true, sorter: "string", headerFilter: "input", headerSortStartingDir: "asc", formatter: function (cell, formatterParams, onRendered) {
        
        let textoAjustado = cell.getValue();
        if (textoAjustado) {
          textoAjustado = textoAjustado.replace(/(\d{2})(\d{5})(\d{4})/,
          function (regex, arg1, arg2, arg3) {
              return '(' + arg1 + ') ' + arg2 + '-' + arg3;
            });
          }
          return textoAjustado;
        }
      },
      { title: 'Editar', formatter: editIcon, width: 50, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { editCadastro(cell.getRow().getData().id) } },
      { title: 'Zap', formatter: iconwhatsappweb, width: 30, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { whatsappweb(cell.getRow().getData().name, cell.getRow().getData().fone) } },
      { title: 'Anamnese', formatter: () => "<i class='fas fa-notes-medical' title='Anamnese capilar'></i>", width: 90, headerSort: false, responsive: 0, hozAlign: 'center', cellClick: (e,cell) => consultarAnaCliente(cell.getRow().getData()) },
      { title: 'Agendas', formatter: iconAgendas, width: 70, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { visualizarHist(cell.getRow().getData().id, cell.getRow().getData().name) } },
      { title: 'CC', formatter: cell => clientesComCC[Number(cell.getRow().getData().id)] ? '<i class="fas fa-calculator" title="Extrato Ficha CC"></i>' : '', width: 48, headerSort: false, responsive: 0, hozAlign: 'center', cellClick: (e,cell) => { const cliente = cell.getRow().getData(); if (clientesComCC[Number(cliente.id)]) visualizarExtratoCC(cliente); } },
      {title:'Permuta',width:75,headerSort:false,responsive:0,hozAlign:'center',formatter:cell=>temHistoricoModalidade(cell.getRow().getData(),'permuta')?'<i class="fa fa-handshake-o" title="Extrato de permuta"></i>':'',cellClick:(e,cell)=>{const c=cell.getRow().getData();if(temHistoricoModalidade(c,'permuta'))setClientePermuta({id:c.id,nome:c.name});}},
      {title:'Pré-pago',width:75,headerSort:false,responsive:0,hozAlign:'center',formatter:cell=>temHistoricoModalidade(cell.getRow().getData(),'pre_pago')?'<i class="fa fa-gift" title="Extrato de crédito pré-pago"></i>':'',cellClick:(e,cell)=>{const c=cell.getRow().getData();if(temHistoricoModalidade(c,'pre_pago'))setClienteCredito({id:c.id,nome:c.name});}},
      { title: 'Obs', field: 'obs', hozAlign: "left", width: 180, responsive: 0, headerSort: true, headerFilter: "input", sorter: "string", headerSortStartingDir: "asc" },
      //{ title: 'Sindico', field: 'sindico', align: "center", width: 150, responsive: 0, headerSort: false },
      /*     {
      title: 'NF Data', field: 'nfe_data', align: 'center', width: 66, responsive: 0, formatter: "datetime", formatterParams: {
        inputFormat: "YYYY-MM-DD",
        outputFormat: "DD/MM/YY",
        invalidPlaceholder: "",
      }, sorter: "string", headerSortStartingDir: "desc", headerSortTristate: true
      }, */
    //{ title: 'Cidade', field: 'cidade', hozAlign: "left", width: 100, responsive: 0, },
    //{ title: 'Valor Parcelas', field: 'vlr_parc', align: "center", width: 150, responsive: 0, headerSort: false },
    //{ title: 'Prazo', field: 'qtdDias', align: "center", width: 80, responsive: 0, headerSort: false },
    //{ title: 'Editar', formatter: editIcon, width: 60, headerSort: false, responsive: 0, hozAlign: "center", cellClick: function (e, cell) { cl(cell.getRow().getData().prop, cell.getRow().getData().nome, cell.getRow().getData().tipo, cell.getRow().getData().sindico, cell.getRow().getData().eleito, cell.getRow().getData().rg, cell.getRow().getData().cpf, cell.getRow().getData().profiss, cell.getRow().getData().estadocivil, cell.getRow().getData().nomet1, cell.getRow().getData().rgt1, cell.getRow().getData().nomet2, cell.getRow().getData().rgt2) } },
    //{ title: 'Gerar', formatter: wordIcon, width: 60, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { geraWordContr(cell.getRow().getData().numcontr) } },
    //{ title: 'Deletar', formatter: iconLixeira, width: 60, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { confirmDelProp(cell.getRow().getData().prop, cell.getRow().getData().nome) } },

    // { title: 'Nome', field: 'nameC', width: 150, responsive: 0, headerFilter: "input", sorter: "string", headerSortStartingDir: "asc" },
    // { title: 'Email', field: 'email', width: 170, responsive: 0, headerFilter: "input" },
    // { title: 'Cidade/Estado', field: 'cidstate', align: 'center', width: 120, responsive: 0 },
    // { title: 'Fone', field: 'fone', align: 'center', width: 100, responsive: 0 },
    // { title: 'Origem', field: 'origem', align: 'center', headerFilter: "input", width: 100, responsive: 0 },
    //{ title: 'Age', field: 'age', align: 'left', formatter: 'progress' },
    //{ title: 'Favourite Color', field: 'color' },
    //{ title: "Progresso", field: "progress", headerSort: false, responsive: 0, formatter: "progress", formatterParams: { color: ["#ff730096", "#00bddc", "#18cc3d"] }, sorter: "number", width: 100 },
    //{ title: 'Rating', field: 'rating', align: 'center', formatter: 'star' },
    // { title: 'Link', field: 'passed', headerSort: false, align: 'center', formatter: 'tickCross', width: 60, responsive: 0 },
    //{ title: 'Info', field: 'msginfo', align: "center", width: 80, headerSort: false, formatter: infoIcon, responsive: 0, cellClick: function (e, cell) { modalBase(cell.getRow().getData().nameC, cell.getRow().getData().msginfo) } },
    //{ title: 'Q?', field: 'resp', headerSort: false, align: "center", formatter: 'tickCross', width: 30, responsive: 0, cellClick: function (e, cell) { cardquestion(cell.getRow().getData().nameC, cell.getRow().getData().email, cell.getRow().getData().chave, cell.getRow().getData().resp) } },
    //{ title: '@', formatter: emailIcon, width: 30, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { iconSendMail(cell.getRow().getData().nameC, cell.getRow().getData().email, cell.getRow().getData().chave) } },
    //{ title: 'Del', formatter: iconLixeira, width: 25, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { if (cell.getRow().getData().progress < 11){ confirmDel(cell.getRow().getData().nameC, cell.getRow().getData().chave) }} },
    // { formatter: printIcon, width: 40, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { alert("Em desenvolvimento, você clickou no nome : " + cell.getRow().getData().nameC) } },
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    // { title: 'Custom', field: 'custom', align: 'center', formatter: reactFormatter(<SimpleButton />) },
    //{ title: 'Custom', field: 'custom', align: 'center' },
  ];

  const columnsHist = [
    {formatter:'responsiveCollapse',width:28,minWidth:28,headerSort:false,resizable:false,responsive:0},
    //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
    { title: 'Ações', hozAlign:'center', width:82, headerSort:false, formatter:cell => {
        const a=cell.getRow().getData();
        const permitido=a.status==='inicial' && !a.idcaixamov && moment(a.start,'DD/MM/YYYY HH:mm',true).isAfter(moment());
        return permitido ? '<i class="fas fa-edit mbcli-acao-editar" title="Editar agendamento" style="color:#17a2b8;cursor:pointer;padding:5px"></i><i class="fas fa-times mbcli-acao-cancelar" title="Cancelar agendamento" style="color:#dc3545;cursor:pointer;padding:5px"></i>' : '';
      }, cellClick:(e,cell)=>{const a=cell.getRow().getData();if(a.status!=='inicial'||a.idcaixamov||!moment(a.start,'DD/MM/YYYY HH:mm',true).isAfter(moment()))return;const el=e.target.closest('i');if(!el)return;if(el.classList.contains('mbcli-acao-editar'))abrirAcaoIndividual(a,'editar');if(el.classList.contains('mbcli-acao-cancelar'))abrirAcaoIndividual(a,'cancelar');} },
    { title: 'Id', field: 'id', hozAlign: 'center', width: 60, responsive: 0, headerFilter: "input", formatter: cell => '<span class="mbcli-id-agenda" title="Visualizar agendamento completo">' + cell.getValue() + '</span>', cellClick: (e,cell) => visualizarDetalheAgenda(cell.getRow().getData().id) },
    // // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
    //{ title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
    { title: 'Profissional', field: 'prof', hozAlign: "left", width: 110, minWidth:110, responsive: 0, headerSort: true, headerFilter: "input", sorter: "string", headerSortStartingDir: "asc" },
    { title: 'Agendamento', field: 'start', hozAlign: "left", width: 140, responsive: 0, headerSort: true, sorter: "string" },
    { title: 'Dia', field: 'start', hozAlign:'center', width:82, headerSort:false, formatter:cell=>diaSemanaCliente(cell.getValue()) },
    { title: 'Status', field: 'status', hozAlign: "center", width: 100, responsive: 0, headerSort: true, sorter: "string", formatter: cell => {const s=String(cell.getValue()||'').toLowerCase();const allowed=['inicial','aguardando','atendimento','finalizado','cancelado','faltou','atrasado','bloqueado','espera'];return '<span class="mbcli-status mbcli-status-'+(allowed.includes(s)?s:'desconhecido')+'">'+String(cell.getValue()||'-').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')+'</span>';} },
    { title: 'Serviços', field: 'servicos', hozAlign: "left", width: 170, tooltip:true, formatter:'plaintext', responsive: 0, headerFilter: "input", headerSort: true, sorter: "string" },
    { title:'Insumos', field:'insumos', hozAlign:'left', width:125, tooltip:true, headerSort:false, formatter:cell=>{const v=cell.getValue();return v ? String(v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;') : '-';} },
    { title: 'Total OS R$', field: 'valor', hozAlign: "left", width: 100, responsive: 0, headerFilter: "input", headerSort: true, sorter: "string" },
    { title: 'Múltiplo', field: 'multiplo', hozAlign:'center', width:95, headerSort:false, formatter: cell => cell.getValue() ? '<span class="mbcli-id-agenda" title="Gerenciar lote">'+cell.getValue()+'</span>' : '-', cellClick:(e,cell)=>{const id=cell.getValue();if(id)abrirLote(id);} },
    { title: 'Obs', field: 'obs', hozAlign: "left", width: 200, responsive: 2 },
    { title: 'Caixa(dia)', field: 'caixa', hozAlign: "center", width: 95, responsive: 1 },
    { title: 'ID Caixa', field: 'idcaixamov', hozAlign: "center", width: 72, responsive: 0, headerSort: true, sorter: "string", formatter: cell => {
      const valor=String(cell.getValue()??'').trim();
      return /^[1-9]\d*$/.test(valor) && Number.isSafeInteger(Number(valor)) ? formatarIdMovimentoCaixa(cell) : '';
    }, cellClick:(e,cell)=>{
      const valor=String(cell.getValue()??'').trim();
      if (!/^[1-9]\d*$/.test(valor) || !Number.isSafeInteger(Number(valor))) return;
      if (e.stopPropagation) e.stopPropagation();
      visualizarMovimentoCC(Number(valor),true);
    } },
  ];

  /*   const columnsProp = [
      //{ formatter: "responsiveCollapse", headerSort: false, width: 30, minWidth: 30, align: "center", resizable: false, responsive: 0 },
      //{ title: 'Id', field: 'id', align: 'center', width: 40, visible: false, responsive: 0 },
      // {
      //  title: 'Data', field: 'createdAt', align: 'center', width: 80, responsive: 0, formatter: "datetime", formatterParams: {
      //    inputFormat: "YYYY-MM-DD",
      //   outputFormat: "DD/MM/YY",
      //   invalidPlaceholder: "(invalid date)",
      // }, sorter: "string", headerSortStartingDir: "desc", headerSortTristate: true
      // },
      // { title: 'Data', field: 'createdAt' ,align: 'center', formatter: DataFormatter, width: 80, responsive:0, headerFilter:"input"},
      { title: 'Chave', field: 'chave', align: 'center', width: 40, visible: false, responsive: 0 },
      { title: 'Tipo', field: 'tipo', align: "center", width: 200, responsive: 0, },
      { title: 'Numero', field: 'prop', align: "center", width: 150, responsive: 0, headerSort: true, sorter: "string", headerSortStartingDir: "desc" },
      { title: 'Valor Total', field: 'vlr_total', align: "center", width: 150, responsive: 0, headerSort: false },
      { title: 'Parcelas', field: 'parc', align: "center", width: 80, responsive: 0, headerSort: false },
      { title: 'Valor Parcelas', field: 'vlr_parc', align: "center", width: 150, responsive: 0, headerSort: false },
      { title: 'Prazo', field: 'qtdDias', align: "center", width: 80, responsive: 0, headerSort: false },
      //{ title: 'Download', formatter: wordIcon, width: 80, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { geraWordProp(cell.getRow().getData().chave, cell.getRow().getData().prop) } },
      //{ title: 'Deletar', formatter: iconLixeira, width: 80, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { confirmDelProp(cell.getRow().getData().prop, cell.getRow().getData().tipo, cell.getRow().getData().vlr_total, cell.getRow().getData().chave) } },
      //{ title: 'Contrato', formatter: iconContrato, width: 80, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { alert('Finalizando o desenvolvimento...') } },
      //{ title: 'Email', field: 'email', width: 170, responsive: 0, headerFilter: "input" },
      //{ title: 'Cidade/Estado', field: 'cidstate', align: 'center', width: 120, responsive: 0 },
      //{ title: 'Fone', field: 'fone', align: 'center', width: 130, responsive: 0 },
      //{ title: 'Info', field: 'msginfo', cellClick: function (e, cell) { modalBase(cell.getRow().getData().nameC, cell.getRow().getData().msginfo) } },
      //{ title: 'Origem', field: 'origem', align: 'center', headerFilter: "input", width: 100, responsive: 0 },
      //{ title: 'Age', field: 'age', align: 'left', formatter: 'progress' },
      //{ title: 'Favourite Color', field: 'color' },
      //{ title: "Progresso", field: "progress", headerSort: false, responsive: 0, formatter: "progress", formatterParams: { color: ["#ff730096", "#00bddc", "#18cc3d"] }, sorter: "number", width: 100 },
      //{ title: 'Rating', field: 'rating', align: 'center', formatter: 'star' },
      // { title: 'Link', field: 'passed', headerSort: false, align: 'center', formatter: 'tickCross', width: 60, responsive: 0 },
      //{ title: 'Q?', field: 'resp', headerSort: false, formatter: 'tickCross', width: 30, responsive: 0, cellClick: function (e, cell) { cardquestion(cell.getRow().getData().nameC, cell.getRow().getData().email, cell.getRow().getData().chave, cell.getRow().getData().resp) } },
      //{ title: 'Zap', formatter: iconwhatsappweb, width: 30, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { whatsappweb(cell.getRow().getData().nameC, cell.getRow().getData().fone) } },
      // { formatter: printIcon, width: 40, headerSort: false, responsive: 0, align: "center", cellClick: function (e, cell) { alert("Em desenvolvimento, você clickou no nome : " + cell.getRow().getData().nameC) } },
      // { title: 'Custom', field: 'custom', align: 'center', formatter: reactFormatter(<SimpleButton />) },
      //{ title: 'Custom', field: 'custom', align: 'center' },
    ]; */

  const options = {
    initialFilter:clienteVisivelNaBusca,
    initialHeaderFilter:filtrosClientes.current,
    placeholder:'Digite um nome, telefone ou observação nos filtros para pesquisar.',

    height: 215,
    // movableRows: true,
    clipboard: true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:["APP_Teste"],
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout: "collapse",
    initialSort: [
      { column: "name", dir: "asc" }, //sort by this first
    ]
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };
  const optionsHist = {
    height: 315,
    // movableRows: true,
    clipboard: true,
    //invalidOptionWarnings: false,
    responsiveLayoutCollapseStartOpen: false,
    //groupBy:"origem",
    //groupValues:["APP_Teste"],
    //selectable:1,
    //selectablePersistence:false,
    responsiveLayout:'collapse',
    columnDefaults:{responsive:0}, // Somente Obs e Caixa(dia) podem ser recolhidas.
    tooltipGenerationMode:'hover',
    initialSort: [
      { column: "name", dir: "asc" }, //sort by this first
    ]
    // pagination:"local",
    // paginationSize:12,
    // paginationSizeSelector:[10, 25, 50, 100],

  };

  function Cadastro(params) {
    if(salvandoCadastro)return;setErroCadastro('');
    if(limiteCadastro===null&&!limiteEmAuditoria){setErroCadastro('Informe um limite CC válido, sem valor negativo.');return;}

    let setid = 0;
    //cl("global.gLog",global.gLog);
    //cl("global.gLog.id",global.gLog['id']);

    global.inpAddFrmC.inputNome=false;global.inpAddFrmC.inputFone=false;
    validaNome(1);validaFone(1);
    if(!global.inpAddFrmC.inputNome||!global.inpAddFrmC.inputFone)return;


    if (global.gLog['id'] > 0) { setid = global.gLog['id'] };




    global.gAtuCad = 1;
    setAtuCad(
      {
        'id': setid,
        'name': document.getElementById('inputNome').value,
        'email': document.getElementById('inputEmail4').value,
        'fone': document.getElementById('inputFone').value,
        'dtnasc': document.getElementById('inputDtnasc').value,
        'end': document.getElementById('inputEnd').value,
        'num': document.getElementById('inputNum').value,
        'compl': document.getElementById('inputCompl').value,
        'cidade': document.getElementById('inputCid').value,
        'estado': document.getElementById('inputEstado').value,
        'cep': document.getElementById('inputCep').value,
        'bairro': document.getElementById('inputBairro').value,
        'obs': document.getElementById('inputObs').value,
        limite_credito:limiteEmAuditoria?'':decimalCaixa(limiteCadastro||0),revisao:global.gLog.revisao||''
      });




  }


  function whatsappweb(nome, fone) {
    let link = "https://api.whatsapp.com/send?phone=55" + fone.replace(/_|-| |\(|\)/g, '') + "&text=Olá " + nome
    window.open(link, '_blank');

  }

  function novoCadastro(params) {
    setTextoLimiteCadastro('R$ 0,00');setLimiteCadastro(0);setLimiteEmAuditoria(false);setClienteEditando(false);setErroCadastro('');
    let etituloContr = document.getElementById('tituloContr');
    etituloContr.innerHTML = "Novo Cadastro ..."

    global.gLog = [];


    let ele = document.getElementById('panelActions');
    ele.style.display = '';

    let elenome = document.getElementById('inputNome');
    elenome.value = '';
    elenome.disabled = false;
    elenome.focus();

    let einputEmail4 = document.getElementById('inputEmail4');
    einputEmail4.value = '';

    let einputDtnasc = document.getElementById('inputDtnasc');
    einputDtnasc.value = '';

    let einputFone = document.getElementById('inputFone');
    einputFone.value = '';

    let einputEnd = document.getElementById('inputEnd');
    einputEnd.value = '';

    let einputNum = document.getElementById('inputNum');
    einputNum.value = '';

    let einputCep = document.getElementById('inputCep');
    einputCep.value = '';

    let einputCompl = document.getElementById('inputCompl');
    einputCompl.value = '';

    let einputBairro = document.getElementById('inputBairro');
    einputBairro.value = '';

    let einputCid = document.getElementById('inputCid');
    einputCid.value = '';

    let einputEstado = document.getElementById('inputEstado');
    einputEstado.value = '';

    let einputObs = document.getElementById('inputObs');
    einputObs.value = '';

  }

  function editCadastro(params) {
    setErroCadastro('');setClienteEditando(true);const registro=rep.find(c=>c.id===params);setTextoLimiteCadastro(registro?.limite_credito===null?'':moedaCaixa(centavosDigitados(registro?.limite_credito)||0));setLimiteEmAuditoria(registro?.limite_credito===null);setLimiteCadastro(registro?.limite_credito===null?null:centavosDigitados(registro?.limite_credito));

    let ele = document.getElementById('panelActions');
    ele.style.display = '';

    let etituloContr = document.getElementById('tituloContr');
    etituloContr.innerHTML = "Editar Cadastro ..."

    var arrFound = rep.filter(function (item, num) {
      return item.id === params;
    });

    global.gLog = arrFound[0];
    //cl("global.gLog",global.gLog);
    let dtfinal = '';
    if (arrFound[0].dtnasc) {

      let dt = arrFound[0].dtnasc.split("/");
      dtfinal = '' + dt[2] + '-' + dt[1] + '-' + dt[0] + '';
    } else {
      dtfinal = '';
    }

    //cl(dtfinal);

    let elenome = document.getElementById('inputNome');
    elenome.value = arrFound[0].name;
    //elenome.disabled = true;

    let einputEmail4 = document.getElementById('inputEmail4');
    einputEmail4.value = arrFound[0].email;

    let einputDtnasc = document.getElementById('inputDtnasc');
    einputDtnasc.value = dtfinal;

    let einputFone = document.getElementById('inputFone');
    einputFone.value = arrFound[0].fone;

    let einputEnd = document.getElementById('inputEnd');
    einputEnd.value = arrFound[0].end;

    let einputNum = document.getElementById('inputNum');
    einputNum.value = arrFound[0].num;

    let einputCep = document.getElementById('inputCep');
    einputCep.value = arrFound[0].cep;

    let einputCompl = document.getElementById('inputCompl');
    einputCompl.value = arrFound[0].compl;

    let einputBairro = document.getElementById('inputBairro');
    einputBairro.value = arrFound[0].bairro;

    let einputCid = document.getElementById('inputCid');
    einputCid.value = arrFound[0].cidade;

    let einputEstado = document.getElementById('inputEstado');
    einputEstado.value = arrFound[0].estado;

    let einputObs = document.getElementById('inputObs');
    einputObs.value = arrFound[0].obs;

    validaFone();


  }




  function realParaNumber(texto) {
    var compativelComParseFloat = texto.replace(/R|\$|\./g, '');
    // //cl("texto R$",compativelComParseFloat);
    compativelComParseFloat = compativelComParseFloat.replace(/,/g, '.');
    ////cl("texto ,.",compativelComParseFloat);
    var valor = parseFloat(compativelComParseFloat);
    // //cl("valor",valor);

    return valor;
  }

  function CalcSimule(params) {

    var iNf_valor = document.getElementById("inputNf_valor");
    let V_Nf_valor = realParaNumber(iNf_valor.value);
    if (V_Nf_valor) { iNf_valor.value = V_Nf_valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }

    var iVlr_pago = document.getElementById("inputVlr_pago");
    let V_pago = realParaNumber(iVlr_pago.value);
    if (V_pago) { iVlr_pago.value = V_pago.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }

    var iDif = document.getElementById("inputDif");
    let V_dif = realParaNumber(iDif.value);
    if (V_dif) { iDif.value = V_dif.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }

    var iPcc = document.getElementById("inputPcc");
    let V_Pcc = realParaNumber(iPcc.value);
    if (V_Pcc) { iPcc.value = V_Pcc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }); }

    if ((iNf_valor.disabled === false) && (iVlr_pago.disabled === false) && (iDif.disabled === false)) {
      V_dif = V_pago - V_Nf_valor;
      if (V_dif > 0) {
        iDif.value = V_dif.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      }
    }

    if ((iNf_valor.disabled === false) && (iPcc.disabled === false)) {
      V_Pcc = V_Nf_valor * 0.045;
      if (V_Pcc > 0) {
        iPcc.value = V_Pcc.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      }
    }




  }

  function confirmDelProp(numprop, cliente) {
    //    var testeStr = 'Isso é um teste <<nome>>';
    //    testeStr = testeStr.replace('<<nome>>', nome)
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            {/* <h1>Deseja Deletar este registro ? {testeStr}</h1><br></br><br></br> */}
            <h1>Deseja Deletar este Contrato da proposta ?</h1><br></br><br></br>
            <p id='pmodal'><b>{numprop} - {cliente}</b></p>
            <br></br>
            <button className="btn bg-gradient-info btn-sm" onClick={onClose}>Não</button>
            <button
              className="btn bg-gradient-danger btn-sm float-right"
              onClick={() => {
                //alert('Em desenvolvimento no backend/servidor');
                /*                 setDelContr(
                                  {
                                    'numprop': numprop
                                  }); */
                onClose();
              }}
            >
              Sim, apague agora!
            </button>
          </div>
        );
      }
    });
  }

  function dataTable(params) {

    return (
      <>
        <div className="card card-info cardGridBgg" id="cardOcorrencias" style={{ display: '' }}>
          <div className="card-header ui-sortable-handle gertitle locCont" >
            <h3 className="card-title locCont">Clientes Cadastrados</h3>

            <div className="card-tools locCont">
              {/* <button type="button" className="btn bg-gradient-info btn-sm " onClick={null} style={{ margin: '-3px 20px' }}>Novo Contato</button> */}
              <Hotkeys
                keyName="shift+c"
                onKeyDown={novoCadastro}
              //onKeyUp={novoContato}
              />
              <button type="button" className="btn bg-gradient-info btn-sm " onClick={novoCadastro} style={{ margin: '-3px 20px' }}>Novo Cadastro &#40;Shift+C&#41;</button>
              <UnificarCadastroCliente aoConcluir={() => {setrepHist([]);setClienteHistoricoId(0);sequenciaDetalheAgenda.current++;setDetalheAgenda(null);setExtratoCC(null);setAtu({unificacao:Date.now()});window.alert('Cadastros unificados com registro de auditoria.');}}/>
              <button type="button" className="btn btn-tool" data-widget="collapse">
                <i className="fas fa-minus" id="cardGridBggI" />
              </button>

              {/* <button type="button" className="btn bg-gradient-info btn-sm " onClick={enviarEmail} style={{ margin: '-3px 20px' }}>Email</button> */}

            </div>
          </div>
          <div className="card-body locCont" id="cardGridBggBody">
            {erroIndicadoresCC && <div className="alert alert-warning mb-1" role="alert">{erroIndicadoresCC}</div>}
            {filtroClienteRota && <div className="px-2 py-2" style={{background:'#eef8fb',borderBottom:'1px solid #c8e5ef'}}><span>Filtro automático: <strong>{clienteRota.nome || ('Cliente #'+clienteRota.id)}</strong></span><button type="button" className="btn btn-outline-secondary btn-sm ml-3" onClick={()=>{filtrosClientes.current=[];setFiltroClienteRota(false);fecharHistCliente();setClienteHistoricoId(0);window.history.replaceState(null,'','/clientes');}}>Limpar filtro e pesquisar outros clientes</button></div>}
            <div onChangeCapture={e=>{if(e.target && e.target.closest('.tabulator-header-filter')){if(filtroClienteRota){setFiltroClienteRota(false);window.history.replaceState(null,'','/clientes');} fecharHistCliente();setClienteHistoricoId(0);}}}>
            <ReactTabulator
              key={'clientes-cc-indicadores-' + versaoIndicadoresCC}
              // ref={(ref)}
              columns={columns}
              data={filtroClienteRota && clienteRota.id ? rep.filter(x=>Number(x.id)===clienteRota.id) : rep}
              /*               rowClick={rowClick}
                            cellClick={rowClick} */
              options={options}
              events={{dataFiltering:antesDeFiltrarClientes,tableBuilt:focarNomeAoCarregarClientes}}
            //data-custom-attr="test-custom-attribute"
            //className="#example-table-theme"
            />
            </div>

            <div id="divLoad" className="load" style={{ display: 'none' }}> <i className="fa fa-cog fa-spin fa-5x fa-fw"></i></div>
          </div>
        </div>
      </>
    )

  }


  function page1(params) {
    return (
      <div id="panelActions" name="panelActions" style={{ position: 'relative', display: 'none' }}>
        <section className="content">
          <div className="row">
            {/* Left col */}
            <section className="col-lg-12 connectedSortable ui-sortable">
              {/* Custom tabs (Charts with tabs)*/}

              <div className="card card-info cardAddBgg" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloContr">Novo Cadastro...</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  {/* Conversations are loaded here */}
                  <form id="formAddNewContact">
                    {erroCadastro&&<div className="alert alert-danger" role="alert">{erroCadastro}</div>}
                    <div className="form-group" style={{maxWidth:320}}><label htmlFor="inputLimiteCC">Limite de Crédito CC</label><input id="inputLimiteCC" className="form-control" inputMode="decimal" disabled={!clienteEditando||limiteEmAuditoria||salvandoCadastro} key={String(clienteEditando)+':'+String(global.gLog?.id)+':'+String(limiteEmAuditoria)} value={textoLimiteCadastro} placeholder={limiteEmAuditoria?'Em auditoria — limite indefinido':'R$ 0,00'} onChange={e=>{setTextoLimiteCadastro(e.target.value);setLimiteCadastro(centavosDigitados(e.target.value));}} onBlur={()=>{if(limiteCadastro!==null)setTextoLimiteCadastro(moedaCaixa(limiteCadastro));}}/><small>{limiteEmAuditoria?'A ficha permanece em auditoria. Use Finalizar Auditoria para definir o limite.':!clienteEditando?'Novos clientes iniciam com limite CC zero.':'Alterações são auditadas e não autorizam pagamentos CC.'}</small></div>
                    <div className="form-row">
                      <div className="form-group col-md-5">
                        <label htmlFor="lNome">Nome*</label>
                        <input type="text" className="form-control" onChange={e => validaNome(e.target.value)} id="inputNome" placeholder="Nome" />
                      </div>
                      <div className="form-group col-md-7">
                        <label htmlFor="lEmail4">Email*</label>
                        <div className="input-group-prepend">
                          <span className="input-group-text">@</span>
                          <input type="email" className="form-control" onChange={e => validaEmail4(e.target.value, 'inputEmail4')} id="inputEmail4" placeholder="Email" />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-4">
                        <label htmlFor="lFone">Fone*</label>
                        <div className="input-group-prepend">
                          <span className="input-group-text">📲</span>
                          <input type="text" className="form-control" onChange={e => validaFone(e.target.value)} placeholder="Ex: 11 99901-XXXX" id="inputFone" />
                        </div>
                      </div>
                      <div className="form-group col-md-4">
                        <label htmlFor="lEmail4">Nascimento</label>
                        <div className="input-group-prepend">
                          <input type="date" className="form-control" id="inputDtnasc" />
                        </div>
                      </div>
                      <div className="form-group col-md-4">
                        <label htmlFor="lCep">CEP</label>
                        <div className="input-group-prepend">
                          <input type="text" className="form-control" id="inputCep" />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-9">
                        <label htmlFor="lEnd">Endereço</label>
                        <div className="input-group-prepend">
                          <input type="text" className="form-control" placeholder="Ex: Rua, Av, ..." id="inputEnd" />
                        </div>
                      </div>
                      <div className="form-group col-md-1">
                        <label htmlFor="lNum">Nº</label>
                        <div className="input-group-prepend">
                          <input type="text" className="form-control" placeholder="Ex: 315A" id="inputNum" />
                        </div>
                      </div>
                      <div className="form-group col-md-2">
                        <label htmlFor="lCompl">Compl</label>
                        <div className="input-group-prepend">
                          <input type="text" className="form-control" placeholder="Ex: AP12" id="inputCompl" />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-5">
                        <label htmlFor="lBairro">Bairro</label>
                        <input type="text" className="form-control" placeholder="Ex: São Paulo - SP" id="inputBairro" />
                      </div>
                      <div className="form-group col-md-5">
                        <label htmlFor="lCity">Cidade</label>
                        <input type="text" className="form-control" placeholder="Ex: São Paulo - SP" id="inputCid" />
                      </div>
                      <div className="form-group col-md-2">
                        <label htmlFor="lEst">Estado</label>
                        <input type="text" className="form-control" placeholder="Ex: São Paulo - SP" id="inputEstado" />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="lObs">Obs</label>
                      <input type="text" className="form-control" id="inputObs" placeholder="Obs" />
                    </div>
                    <button type="button" className="btn btn-info " id="btnGravar" disabled={salvandoCadastro} onClick={e => Cadastro()}>Gravar</button>
                    <button type="button" className="btn btn-info float-right" id="btnGravarClose" onClick={e => CloseEditContr()}>Cancelar</button>
                  </form>
                </div>

              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }

  function cliHist(params) {
    return (
      <div id="panelHist" name="panelHist" style={{ position: 'relative', display: 'none' }}>
        <div id="divLoadHist" className="load" style={{ display: 'none' }}> <i className="fa fa-cog fa-spin fa-5x fa-fw"></i></div>
        <section className="content">
          <div className="row">
            <section className="col-lg-12 connectedSortable ui-sortable">

              <div className="card card-info cardAddBgg" >
                <div className="card-header ui-sortable-handle" >
                  <h3 className="card-title" id="tituloHist">Histórico de Agendamentos</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" onClick={fecharHistCliente} title="Fechar histórico">
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body locCont" id="cardGridBggBody">
                  <ReactTabulator
                    // ref={(ref)}
                    columns={columnsHist}
                    data={repHist}
                    /*               rowClick={rowClick}
                                  cellClick={rowClick} */
                    options={optionsHist}
                    events={{}}
                  //data-custom-attr="test-custom-attribute"
                  //className="#example-table-theme"
                  />

                </div>
              </div>
            </section>

          </div>

        </section>
      </div>

    )

  }


  function painelExtratoCC() {
    if (!extratoCC) return null;
    const saldo = Number(extratoCC.saldo || 0);
    const movimentos = extratoCC.movimentos || [];
    const auditado = extratoCC.limite_credito !== null && extratoCC.limite_credito !== undefined && extratoCC.limite_credito !== '';
    return <div id="panelExtratoCC" className="mbcli-panel-cc">
      <section className="content"><div className="card card-info cardAddBgg">
        <div className="card-header"><h3 className="card-title">{extratoCC.cliente.name} — Extrato de Ficha (CC) <span className={'mbcli-auditoria ' + (auditado ? 'mbcli-auditado' : 'mbcli-nao-auditado')} title={auditado ? 'Conta auditada — limite de crédito cadastrado' : 'Conta em auditoria — limite de crédito não definido'}><i className="fas fa-flag" /> {auditado ? 'Auditada' : 'Em auditoria'}</span></h3>
          <div className="card-tools"><button type="button" className="btn btn-tool" onClick={() => setExtratoCC(null)} title="Fechar extrato"><i className="fas fa-times" /></button></div>
        </div>
        <div className="card-body">
          {carregandoCC ? <p>Carregando extrato...</p> : erroCC ? <div className="alert alert-danger">{erroCC}</div> : <>
            <div className="mbcli-saldos">
              <div className="mbcli-debitos-privados"><span>Débitos CC registrados</span><button type="button" className="mbcli-olho-toggle" onClick={() => setMostrarTotaisCC(v => !v)} aria-label={mostrarTotaisCC ? 'Ocultar totais históricos' : 'Mostrar totais históricos'} title={mostrarTotaisCC ? 'Ocultar os totais de CC e recebimentos' : 'Mostrar os totais de CC e recebimentos'}><i className={'fas ' + (mostrarTotaisCC ? 'fa-eye' : 'fa-eye-slash')} /></button><strong>{mostrarTotaisCC ? moedaClientes(extratoCC.total_debitos) : 'R$ ••••••'}</strong></div>
              <div><span>Recebimentos identificados</span><strong>{mostrarTotaisCC ? moedaClientes(extratoCC.total_pagamentos) : 'R$ ••••••'}</strong></div>
              <div><span>Saldo devedor estimado</span><strong className="mbcli-devedor">{moedaClientes(Math.max(0,saldo))}</strong></div>
              <div><span>Crédito estimado</span><strong className="mbcli-credito">{moedaClientes(Math.max(0,-saldo))}</strong></div>
              {auditado&&<div><span>Limite de crédito CC (total)</span><strong>{moedaClientes(extratoCC.limite_credito)}</strong></div>}
            </div>
            
            {podeAuditarCC && !auditado && <div className="mbcli-auditoria-acoes"><button type="button" className="btn btn-info btn-sm" onClick={()=>abreAuditoriaModal('buscar')}><i className="fas fa-search"/> Localizar Pagamentos</button><button type="button" className="btn btn-warning btn-sm" onClick={()=>abreAuditoriaModal('ajuste')}><i className="fas fa-balance-scale"/> Ajuste de Saldo</button><button type="button" className="btn btn-success btn-sm" onClick={()=>abreAuditoriaModal('finalizar')}><i className="fas fa-check-circle"/> Finalizar Auditoria</button></div>}
            <p className="mbcli-alerta">Saldo histórico estimado: lançamentos anteriores à implantação ou pagamentos de familiares podem exigir conciliação. Crédito exibido não significa crédito disponível confirmado.</p>
            <div className="mbcli-tabela-wrap"><table className="table table-sm table-striped mbcli-extrato-tabela">
              <thead><tr><th>Data</th><th>Mov.</th><th>Agenda</th><th>Descrição</th><th className="text-right">Débito CC</th><th className="text-right">Pagamento</th>{podeAuditarCC && !auditado && <th className="text-center">Ação</th>}</tr></thead>
              <tbody>{movimentos.length ? movimentos.map((m,i) => <tr key={m.tipo + '-' + m.movimento + '-' + i}>
                <td>{dataClientes(m.data)}</td><td><button type="button" className="mbcli-link-id" onClick={() => visualizarMovimentoCC(m.movimento)} title="Abrir detalhes deste movimento">{m.movimento}</button></td><td>{(m.agendas?.length ? m.agendas : m.agenda ? [m.agenda] : []).map((id,i)=><React.Fragment key={id}>{i>0 && ', '}<button type="button" className="mbcli-link-id" onClick={() => visualizarDetalheAgenda(id)} title="Abrir agendamento completo">{id}</button></React.Fragment>)}{!m.agendas?.length && !m.agenda && '-'}</td><td>{m.descricao}</td>
                <td className="text-right mbcli-devedor">{Number(m.debito) > 0 ? moedaClientes(m.debito) : '-'}</td>
                <td className="text-right mbcli-credito">{Number(m.pagamento)>0 ? moedaClientes(m.pagamento) : m.tipo==='AJUSTE' ? moedaClientes(Math.abs(Number(m.ajuste||0)))+' (acerto)' : '-'}</td>
                {podeAuditarCC && !auditado && <td className="text-center">{m.tipo==='RECEBIMENTO' ? <button className="mbcli-desvincular" type="button" title="Desvincular pagamento" onClick={()=>abreAuditoriaModal('desvincular',m)}><i className="fas fa-times"/></button> : m.tipo==='AJUSTE' ? <button className="mbcli-desvincular" type="button" title="Cancelar acerto manual" onClick={()=>abreAuditoriaModal('excluir_ajuste',m)}><i className="fas fa-times"/></button> : ''}</td>}
              </tr>) : <tr><td colSpan={auditado||!podeAuditarCC?6:7} className="text-center">Nenhum lançamento CC localizado para este cliente.</td></tr>}</tbody>
            </table></div>
          </>}
        </div>
      </div></section>
    </div>;
  }
  function modalDetalheMovimento() {
    if (!detalheMovimento) return null;
    const m = detalheMovimento;
    if (movimentoCompleto && !carregandoMovimento && !erroMovimento) {
      return <MovimentoAgendasDetalhe movimento={m} onClose={() => setDetalheMovimento(null)}/>;
    }
    const cols = [['valor','Total'],['cash','Dinheiro'],['troco','Troco'],['debito','Débito'],['creditoavista','Crédito à vista'],['creditoparc','Crédito parcelado'],['pix','PIX'],['cc','Ficha CC'],['pre_pago','Pré-pago utilizado'],['permuta','Permuta']];
    return <div className="mbcli-modal-fundo" role="presentation" onMouseDown={e => {if(e.target===e.currentTarget)setDetalheMovimento(null);}}>
      <div className="mbcli-modal mbcli-modal-mov" role="dialog" aria-modal="true" aria-label="Detalhes da movimentação financeira">
        <div className="mbcli-modal-top"><h4>Movimento de Caixa #{m.id}</h4><button type="button" className="btn btn-sm btn-secondary" onClick={() => setDetalheMovimento(null)}>Fechar</button></div>
        <div className="mbcli-modal-conteudo">
          {carregandoMovimento ? <p>Carregando movimento...</p> : erroMovimento ? <div className="alert alert-danger">{erroMovimento}</div> : <>
            <div className="mbcli-detalhe-grid">
              <div><b>Data:</b> {dataClientes(m.createdAt)}</div><div><b>Tipo:</b> {m.tipo || '-'}</div>
              <div><b>Status:</b> {m.status || '-'}</div><div><b>Caixa:</b> {m.caixa || '-'}</div>
              <div><b>Cliente vinculado:</b> {m.idcliente || '-'}</div><div><b>Referência:</b> {m.ref || '-'}</div>
              <div><b>Agenda:</b> {m.idagenda || '-'}</div><div><b>Operador:</b> {m.user || '-'}</div>
            </div>
            <div className="mbcli-detalhe-obs"><b>Descrição:</b> {m.descricao || '-'}</div>
            <h5>Valores e formas de pagamento</h5>
            <div className="mbcli-detalhe-grid">{cols.map(([campo,rotulo]) => <div key={campo}><b>{rotulo}:</b> {moedaClientes(m[campo])}</div>)}</div>
            {/^\d+$/.test(String(m.idagenda || '').trim()) && <button type="button" className="btn btn-info btn-sm mt-3" onClick={() => {const id=m.idagenda;setDetalheMovimento(null);visualizarDetalheAgenda(id);}}>Abrir agendamento #{m.idagenda}</button>}
          </>}
        </div>
      </div>
    </div>;
  }
  function abrirCaixaDoPagamento(pagamento) {
    const movimento = Number(pagamento?.id);
    if (!Number.isSafeInteger(movimento) || movimento <= 0) return;
    const parametros = new URLSearchParams({movimento_id:String(movimento)});
    const caixaId = Number(pagamento?.caixa_id || pagamento?.idcaixa || pagamento?.caixa || 0);
    if (Number.isSafeInteger(caixaId) && caixaId > 0) parametros.set('caixa_id',String(caixaId));
    const dataCaixa = pagamento?.open || pagamento?.caixa_data || pagamento?.createdAt || pagamento?.data || '';
    const dt = moment(dataCaixa,['YYYY-MM-DD HH:mm:ss','YYYY-MM-DD','DD/MM/YYYY HH:mm:ss','DD/MM/YYYY HH:mm'],true);
    if (dt.isValid()) parametros.set('caixa_data',dt.format('YYYY-MM-DD'));
    window.location.assign('/caixa-consulta?' + parametros.toString());
  }
  function modalDetalheAgenda() {
    if (!detalheAgenda) return null;
    const a = detalheAgenda.agenda || {};
    const fila = (Array.isArray(repHist) ? repHist : []).map(r => Number(r.id)).filter(id => id > 0);
    const posicao = fila.indexOf(Number(a.id));
    const lancamentos = detalheAgenda.lancamentos || [];
    const insumos = detalheAgenda.insumos || [];
    const totais = calcularTotaisOS(lancamentos,insumos);
    // Somente movimentos financeiros efetivos. A API deve retornar o campo status.
    const pagamentos = (detalheAgenda.pagamentos || []).filter(p => String(p.status || '').toLowerCase() === 'inicial');
    return <div className="mbcli-modal-fundo" role="presentation" onMouseDown={e => {if(e.target===e.currentTarget){sequenciaDetalheAgenda.current++;setDetalheAgenda(null);}}}>
      <div className="mbcli-modal" role="dialog" aria-modal="true" aria-label="Detalhamento do agendamento">
        <div className="mbcli-modal-top"><h4>Agendamento #{a.id} — Detalhamento completo</h4><button type="button" className="btn btn-sm btn-secondary" onClick={() => {sequenciaDetalheAgenda.current++;setDetalheAgenda(null);}}>Fechar</button></div>
        <div className="mbcli-modal-conteudo">
          <nav className="d-flex justify-content-between align-items-center mb-3" aria-label="Navegação dos agendamentos">
            <button type="button" className="btn btn-outline-info btn-sm" disabled={carregandoDetalhe || posicao <= 0} onClick={() => visualizarDetalheAgenda(fila[posicao - 1])}>← Anterior</button>
            <span>{posicao >= 0 ? (posicao + 1) + ' de ' + fila.length : ''}</span>
            <button type="button" className="btn btn-outline-info btn-sm" disabled={carregandoDetalhe || posicao < 0 || posicao >= fila.length - 1} onClick={() => visualizarDetalheAgenda(fila[posicao + 1])}>Próximo →</button>
          </nav>
          {carregandoDetalhe ? <p>Carregando detalhes...</p> : erroDetalhe ? <div className="alert alert-danger">{erroDetalhe}</div> : <>
            <div className="mbcli-detalhe-grid"><div><b>Cliente:</b> {a.cliente_nome || '-'}</div><div><b>Profissional:</b> {a.profissional || '-'}</div><div><b>Início:</b> {dataClientes(a.start)} — {diaSemanaCliente(a.start)}</div><div><b>Fim:</b> {dataClientes(a.end)}</div><div><b>Status:</b> {a.status || '-'}</div><div><b>Movimento caixa vinculado:</b> {a.idcaixamov || '-'}</div></div>
            <div className="mbcli-detalhe-obs"><b>Observações:</b> {a.obs || '-'}</div>
            <ResumoTotaisOS totais={totais}/>
            <h5>Serviços e lançamentos</h5>
            <div className="mbcli-tabela-wrap"><table className="table table-sm table-striped"><thead><tr><th>ID</th><th>Descrição</th><th>Profissional</th><th>Auxiliar FLEX</th><th>Qtd.</th><th className="text-right">Unitário</th><th className="text-right">Subtotal</th></tr></thead><tbody>
              {lancamentos.length ? lancamentos.map(l => <tr key={l.id}><td>{l.id}</td><td>{l.descricao || '-'}</td><td>{l.profissional || '-'}</td><td>{l.auxiliar_flex || '—'}</td><td>{l.qtd}</td><td className="text-right">{moedaClientes(l.valor)}</td><td className="text-right">{moedaClientes(subtotalOS(l))}</td></tr>) : <tr><td colSpan="7">Nenhum lançamento localizado.</td></tr>}
            </tbody><tfoot><tr><th colSpan="6">Total de serviços e lançamentos</th><th className="text-right">{moedaClientes(totais.os)}</th></tr></tfoot></table></div>
            <h5>Insumos</h5>
            <div className="mbcli-tabela-wrap"><table className="table table-sm table-striped"><thead><tr><th>ID</th><th>Descrição</th><th>Qtd.</th><th className="text-right">Custo unitário</th><th className="text-right">Subtotal</th></tr></thead><tbody>
              {insumos.length ? insumos.map(i => <tr key={i.id}><td>{i.id}</td><td>{i.descricao || '-'}</td><td>{i.qtd}</td><td className="text-right">{moedaClientes(i.valor)}</td><td className="text-right">{moedaClientes(subtotalOS(i))}</td></tr>) : <tr><td colSpan="5">Nenhum insumo localizado.</td></tr>}
            </tbody><tfoot><tr><th colSpan="4">Total de insumos (custo)</th><th className="text-right">{moedaClientes(totais.insumos)}</th></tr></tfoot></table></div>
            <h5>Movimentações financeiras e formas de pagamento</h5>
            <div className="mbcli-tabela-wrap"><table className="table table-sm table-striped"><thead><tr><th>Mov.</th><th>Data</th><th>Descrição</th><th>Tipo</th><th className="text-right">Total do movimento</th><th className="text-right">Dinheiro</th><th className="text-right">Troco</th><th className="text-right">Débito</th><th className="text-right">Crédito</th><th className="text-right">Créd. parc.</th><th className="text-right">PIX</th><th className="text-right">CC</th><th className="text-right">Pré-pago</th><th className="text-right">Permuta</th></tr></thead><tbody>
              {pagamentos.length ? pagamentos.map(p => <tr key={p.id}><td><button type="button" className="btn btn-link btn-sm p-0 font-weight-bold" title="Localizar este lançamento no caixa" onClick={()=>abrirCaixaDoPagamento(p)}>{p.id}</button></td><td>{dataClientes(p.createdAt)}</td><td>{p.descricao}</td><td>{p.tipo}</td>{['valor','cash','troco','debito','creditoavista','creditoparc','pix','cc','pre_pago','permuta'].map(c=><td key={c} className="text-right">{moedaClientes(p[c])}</td>)}</tr>) : <tr><td colSpan="14">Nenhuma movimentação de caixa vinculada localizada.</td></tr>}
            </tbody></table></div>
            <p className="mbcli-alerta">O total da OS soma os serviços, produtos e demais lançamentos desta agenda. Insumos são custos separados. Um movimento de caixa pode reunir várias OS: seu total não é o valor individual desta OS. Lançamentos históricos incompletos podem não conter todas as informações.</p>
          </>}
        </div>
      </div>
    </div>;
  }

  function validaNome(params) {
    const eNnome = document.getElementById('inputNome')
    const nome = eNnome.value;
    if (nome.length > 3) {
      eNnome.classList.add("is-valid");
      eNnome.classList.remove("is-invalid");
      global.inpAddFrmC.inputNome = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function validaCid(params) {
    const eNnome = document.getElementById('inputCidade')
    const nome = eNnome.value;
    if (nome.length > 5) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      global.inpAddFrmC.inputCid = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function validaEmail4(params, idinput) {
    const eNemail = document.getElementById('inputEmail4')
    const email = eNemail.value;
    if (EmailValidator.validate(email)) {
      eNemail.classList.add("is-valid")
      eNemail.classList.remove("is-invalid")
      global.inpAddFrmC.inputEmail4 = true;
      //cl("true global valida", global.inpAddFrmC)
    } else {
      eNemail.classList.add("is-invalid")
      eNemail.classList.remove("is-valid")
      //cl("FALSE global valida", global.inpAddFrmC, params)
      if (params === 1) { return eNemail.focus() }
    }
    if (email) { eNemail.value = params.toLowerCase() };

  }

  function validaFone(params) {
    const eNnome = document.getElementById('inputFone')
    const nomep = eNnome.value;
    const nome = nomep.replace(/_|-/g, '');
    ////cl(nome)
    if (nome.length > 9) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      global.inpAddFrmC.inputFone = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
    let im = new Inputmask("(99) 99999-9999");
    im.mask(eNnome);

  }

  function formataFone(params) {
    const nome = params.replace(/_|-/g, '');
    ////cl(nome)
    //eNnome.value = params.toLowerCase();
    let im = new Inputmask("99-999999999");
    let result = im.mask(params);
    return result;

  }


  function validaObs(params) {
    const eNnome = document.getElementById('inputObs')
    const nome = eNnome.value;
    if (nome.length > 5) {
      eNnome.classList.add("is-valid")
      eNnome.classList.remove("is-invalid")
      global.inpAddFrmC.inputObs = true;
    } else {
      eNnome.classList.add("is-invalid")
      eNnome.classList.remove("is-valid")
      if (params === 1) { eNnome.focus() }
    }
    //eNnome.value = params.toLowerCase();
  }

  function CloseEditContr(params) {
    let ele = document.getElementById('panelActions');
    ele.style.display = 'none';

    let elenome = document.getElementById('inputNome');
    elenome.value = '';
    elenome.disabled = false;

    let einputEmail4 = document.getElementById('inputEmail4');
    einputEmail4.value = '';

    let einputDtnasc = document.getElementById('inputDtnasc');
    einputDtnasc.value = '';

    let einputFone = document.getElementById('inputFone');
    einputFone.value = '';

    let einputEnd = document.getElementById('inputEnd');
    einputEnd.value = '';

    let einputNum = document.getElementById('inputNum');
    einputNum.value = '';

    let einputCep = document.getElementById('inputCep');
    einputCep.value = '';

    let einputCompl = document.getElementById('inputCompl');
    einputCompl.value = '';

    let einputBairro = document.getElementById('inputBairro');
    einputBairro.value = '';

    let einputCid = document.getElementById('inputCid');
    einputCid.value = '';

    let einputEstado = document.getElementById('inputEstado');
    einputEstado.value = '';

    let einputObs = document.getElementById('inputObs');
    einputObs.value = '';


  }

  if (repCliout.length < 1) {
    //if (0 == 1) {
    return (
      <div className="content-wrapper" >
        <div className="container-login100-form-btn">
          <img id="imgloading" width="250px" alt="Loading.." src={Loading}></img>

        </div>
        <div className="text-center p-t-30">Aguarde, Localizando Clientes ...</div>
      </div >
    )
  } else {
    return (
      <div className="content-wrapper">
        {clientePermuta&&<PermutaCliente clienteInicial={clientePermuta} onClose={()=>setClientePermuta(null)}/>}
        {clienteCredito&&<CreditoPrePagoCliente clienteInicial={clienteCredito} onClose={()=>setClienteCredito(null)}/>}
        {page1()}
        {dataTable()}
        {cliHist()}
        {painelExtratoCC()}
        {modalDetalheAgenda()}
        {painelLote()}
        {modalDetalheMovimento()}
        {modalAuditoriaCC()}
        {modalAnaCliente()}



      </div>
    )

  }


}

export default Gerador   
